<template>
  <div
    class="layout-container"
    :class="{ 'mobile-drawer-open': mobileDrawerOpen, 'mobile-topbar-hidden': mobileTopBarHidden, 'mobile-topbar-overlay': mobileTopBarOverlaysContent, 'ipad-layout': displayState.isIPad }"
  >
    <el-container class="main-container" :class="isDomestic ? 'domestic-layout' : ''">
      <el-aside
        id="layout-navigation"
        ref="navigationAside"
        class="layout-container-aside "
        :class="menuCollapse?'collapse-aside':''"
        :role="navigationOverlayActive ? 'dialog' : null"
        :aria-modal="navigationOverlayActive && mobileDrawerOpen ? 'true' : null"
        :aria-label="$t('layout.layout.navigation')"
        :aria-hidden="isMobileViewport && !mobileDrawerOpen ? 'true' : null"
        :inert="isMobileViewport && !mobileDrawerOpen ? '' : null"
      >
        <div class="sidebar-layout" @scroll.passive="handleSidebarScroll">
          <div class="main-left-sidebar">
            <el-header
              class="header-bar"
              @click="goToDashboard"
            >
              <div class="header-bar-box">
                <div
                  v-show="!menuCollapse || isMobileViewport"
                  class="logo"
                >
                  <template v-if="isMobileViewport">
                    <el-image
                      class="sidebar-brand-symbol"
                      fit="none"
                      :src="require('@/assets/img/logo-notxt.png')"
                      alt=""
                    />
                    <span class="sidebar-brand-name">{{ $t('layout.layout.paiteams') }}</span>
                  </template>
                  <el-image
                    v-else
                    class="logo-not-collapse"
                    fit="contain"
                    :src="require('@/assets/img/logo-letter.png')"
                  />
                </div>
                <a
                  v-show="menuCollapse && !isMobileViewport"
                  href="#"
                  class="logo"
                >
                  <div
                    class="logo-collapse"
                  />
                </a>
                <button
                  ref="mobileDrawerClose"
                  type="button"
                  class="mobile-shell-button mobile-drawer-close"
                  :aria-label="$t('common.close')"
                  @click.stop="closeMobileDrawer()"
                >
                  <el-icon aria-hidden="true"><Close /></el-icon>
                </button>
              </div>
            </el-header>

            <el-menu
              :default-active="menuActiveIndex"
              class="menu-box"
              background-color="none"
              :collapse="menuCollapse && !isMobileViewport"
              @open="openMenu"
              @close="closeMenu"
            >
              <div
                v-for="menuItem in sidebarMenus"
                :key="menuItem.code"
                class="menu-items-box"
              >
                <MobileAgentNavigation
                  v-if="isMobileViewport && mobileDrawerOpen && menuItem.path === '/chat'"
                  :label="menuItem.title"
                  :authenticated="isLoggedIn"
                  :team-id="currentTeamId"
                  :user-id="currentUserId"
                  :active-agent-id="mobileActiveConfig?.navigationAgentId"
                  :active-category="mobileNavigationAgentCategory"
                  @request-login="openLogin"
                  @select="selectMobileNavigationAgent"
                />
                <MobileSidebarListNavigation
                  v-else-if="isMobileViewport && mobileDrawerOpen && menuItem.path === '/projects'"
                  :label="menuItem.title"
                  section-icon-name="Document"
                  control-id="mobile-sidebar-project-options"
                  :overview-label="$t('views.knowledge.all_projects')"
                  overview-path="/projects"
                  :active="menuActiveIndex === menuItem.code"
                  :overview-active="mobileProjectOverviewActive"
                  :authenticated="isLoggedIn"
                  :items="mobileProjectNavigationItems"
                  :loading="$store.getters['mobileNavigation/projectLoading']"
                  :error="$store.getters['mobileNavigation/projectError']"
                  :has-more="$store.getters['mobileNavigation/projectHasMore']"
                  :active-key="mobileProjectActiveKey"
                  item-key-field="id"
                  item-label-field="name"
                  :login-label="$t('layout.layout.navigation_login')"
                  :error-label="$t('layout.layout.navigation_load_failed')"
                  :retry-label="$t('layout.layout.navigation_retry')"
                  :empty-label="$t('layout.layout.navigation_empty')"
                  :more-label="$t('layout.layout.navigation_load_more')"
                  @expand="loadMobileProjectNavigation"
                  @retry="retryMobileProjectNavigation"
                  @load-more="loadMoreMobileProjectNavigation"
                  @select-overview="selectMobileNavigationOverview"
                  @select="selectMobileNavigationProject"
                  @request-login="openLogin"
                />
                <MobileSidebarListNavigation
                  v-else-if="isMobileViewport && mobileDrawerOpen && menuItem.path === '/assets'"
                  :label="menuItem.title"
                  section-icon-name="FolderOpened"
                  control-id="mobile-sidebar-asset-options"
                  :overview-label="$t('views.attachment.all_assets')"
                  overview-path="/assets"
                  :active="menuActiveIndex === menuItem.code"
                  :overview-active="mobileAssetOverviewActive"
                  :authenticated="isLoggedIn"
                  :items="mobileAssetNavigationItems"
                  :loading="$store.getters['mobileNavigation/assetLoading']"
                  :error="$store.getters['mobileNavigation/assetError']"
                  :has-more="$store.getters['mobileNavigation/assetHasMore']"
                  :active-key="mobileAssetActiveKey"
                  item-key-field="code"
                  item-label-field="name"
                  :login-label="$t('layout.layout.navigation_login')"
                  :error-label="$t('layout.layout.navigation_load_failed')"
                  :retry-label="$t('layout.layout.navigation_retry')"
                  :empty-label="$t('layout.layout.navigation_empty')"
                  :more-label="$t('layout.layout.navigation_load_more')"
                  @expand="loadMobileAssetNavigation"
                  @retry="retryMobileAssetNavigation"
                  @load-more="loadMoreMobileAssetNavigation"
                  @select-overview="selectMobileNavigationOverview"
                  @select="selectMobileNavigationAsset"
                  @request-login="openLogin"
                />
                <div
                  v-else-if="(!menuItem.children || menuItem.children.length === 0) && menuItem.show"
                  class="menu-item-wrapper"
                  :class="{ 'is-current': isMobileViewport && menuActiveIndex === menuItem.code }"
                  :role="touchNavigation ? 'link' : null"
                  :tabindex="touchNavigation ? 0 : null"
                  :aria-current="touchNavigation && menuActiveIndex === menuItem.code ? 'page' : null"
                  :aria-label="touchNavigation ? menuItem.title : null"
                  @click="changeNav(menuItem)"
                  @keydown.enter.prevent="touchNavigation && changeNav(menuItem)"
                  @keydown.space.prevent="touchNavigation && changeNav(menuItem)"
                >
                  <div 
                    class="menu-item-box"
                    :class="{'is-active': menuActiveIndex === menuItem.code}"
                  >
                    <el-icon v-if="isMobileViewport" class="menu-icon menu-item-icon" aria-hidden="true">
                      <component :is="menuItem.navigationIcon" />
                    </el-icon>
                    <span v-else-if="menuItem.icon" class="menu-icon">
                      <i
                        v-if="menuItem.iconType === 'iconfont'"
                        class="menu-item-icon icon ag-iconfont"
                        :class="'icon-' + menuItem.icon"
                        aria-hidden="true"
                      />
                      <svg-icon
                        v-else
                        :icon-class="menuActiveIndex === menuItem.code ? menuItem.activeIcon || menuItem.icon : menuItem.icon"
                        class-name="menu-item-icon"
                      />
                    </span>
                  </div>
                  <div 
                  :class="{'is-textactive': menuActiveIndex === menuItem.code}"
                  class="menu-item-label">
                  {{ menuItem.title }}
                </div>
                </div>
                <!-- 隐藏原el-menu-item功能 -->
                <el-menu-item
                  v-if="false && (!menuItem.children || menuItem.children.length === 0) && menuItem.show"
                  :index="menuItem.code"
                  style="display: none;"
                  @click="changeNav(menuItem)"
                >
                  <div class="menu-item-box">
                    <span
                      v-if="menuItem.icon"
                      class="menu-icon"
                    >
                      <svg-icon
                        :icon-class="menuActiveIndex === menuItem.code ? menuItem.activeIcon || menuItem.icon : menuItem.icon"
                        class-name="menu-item-icon"
                      />
                    </span>
                  </div>
                  <template #title>
                    <div class="menu-title">{{ menuItem.title }}</div>
                  </template>
                </el-menu-item>
                <!-- 隐藏原el-sub-menu功能 -->
                <el-sub-menu
                  v-if="false && menuItem.children && menuItem.children.length > 0 && menuItem.show"
                  :index="menuItem.code"
                  style="display: none;"
                >
                  <template #title>
                    <span
                      v-if="menuItem.icon"
                      class="menu-icon"
                    >
                      <i
                        class="menu-item-icon icon ag-iconfont"
                        :class="'icon-'+menuItem.icon"
                      />
                    </span>
                    <div
                      class="menu-title"
                      :class="menuCollapse?'hide-sub-title':''"
                    >{{ menuItem.title }}
                    </div>
                  </template>
                  <div
                    v-for="(subMenuItem,subMenuItemIndex) in menuItem.children"
                    :key="subMenuItemIndex"
                    class="sub-menu-box"
                  >
                    <el-menu-item
                      v-if="(!subMenuItem.children || subMenuItem.children.length === 0) && subMenuItem.show"
                      :index="subMenuItem.code"
                      @click="changeNav(subMenuItem)"
                    >
                      <span
                        v-if="subMenuItem.icon"
                        class="menu-icon"
                      >
                        <i
                          class="menu-item-icon icon ag-iconfont"
                          :class="'icon-'+subMenuItem.icon"
                        />
                      </span>
                      <!--                      <template #title>-->
                      <!--                        <div class="menu-title">{{ subMenuItem.title }}</div>-->
                      <!--                      </template>-->
                    </el-menu-item>
                    <el-sub-menu
                      v-if="subMenuItem.children && subMenuItem.children.length > 0 && subMenuItem.show"
                      :index="subMenuItem.code"
                    >
                      <template #title>
                        <span
                          v-if="subMenuItem.icon"
                          class="menu-icon"
                        >
                          <i
                            class="menu-item-icon icon ag-iconfont"
                            :class="'icon-'+subMenuItem.icon"
                          />
                        </span>
                        <div class="menu-title">{{ subMenuItem.title }}</div>
                      </template>
                      <el-menu-item
                        v-for="(sSubMenuItem,sSubMenuItemIndex) in subMenuItem.children"
                        :key="sSubMenuItemIndex"
                        :index="sSubMenuItem.code"
                        @click="changeNav(sSubMenuItem)"
                      >
                        <span
                          v-if="sSubMenuItem.icon"
                          class="menu-icon"
                        >
                          <i
                            class="menu-item-icon icon ag-iconfont"
                            :class="'icon-'+sSubMenuItem.icon"
                          />
                        </span>
                        <template #title>
                          <div class="menu-title">{{ sSubMenuItem.title }}</div>
                        </template>
                      </el-menu-item>
                    </el-sub-menu>
                  </div>
                </el-sub-menu>
              </div>
            </el-menu>
          </div>
          <div class="bottom-menu-bar">
            <div class="enterprise-contact-wrapper">
              <el-tooltip
                :content="$t('layout.layout.enterprise_contact')"
                effect="dark"
                placement="right"
              >
                <button
                  type="button"
                  class="enterprise-contact-entry"
                  ref="enterpriseContactTrigger"
                  :aria-label="$t('layout.layout.enterprise_contact')"
                  @click="openEnterpriseContact"
                >
                  <el-icon v-if="isMobileViewport" class="enterprise-contact-icon" aria-hidden="true"><OfficeBuilding /></el-icon>
                  <span v-else class="enterprise-contact-icon icon ag-iconfont" aria-hidden="true">&#xe674;</span>
                  <span
                    v-if="!menuCollapse || isMobileViewport"
                    class="enterprise-contact-label"
                  >{{ $t('layout.layout.enterprise_contact') }}</span>
                </button>
              </el-tooltip>
            </div>

            <!-- 手机与桌面共用订阅管理权限，布局仍沿用各自入口。 -->
            <div
              v-if="isMobileViewport && canManageSubscription && $store.getters['user/user_sub'] === 'VER_PERSON_FREE_BASICS'"
              class="upgrade-button-wrapper"
              @click="openSubPage"
            >
              <el-button
                type="primary"
                class="upgrade-text-btn"
              >
                <span class="mobile-sidebar-icon" aria-hidden="true">
                  <el-icon class="menu-icon"><Trophy /></el-icon>
                </span>
                <span class="mobile-sidebar-label">{{ $t('layout.layout.upgrade_to_pro') }}</span>
              </el-button>
            </div>
            <!-- 隐藏升级按钮折叠状态，保留功能 -->
            <div
              v-else-if="canManageSubscription && $store.getters['user/user_sub'] === 'VER_PERSON_FREE_BASICS'"
              class="upgrade-button-wrapper collapsed"
              @click="openSubPage"
            >
              <el-button
                type="primary"
                circle
                class="upgrade-icon-btn"
                :aria-label="$t('layout.layout.upgrade_to_pro')"
              ><svg-icon class-name="menu-icon" icon-class="crown" /></el-button>
            </div>

            <!-- 邀请奖励入口 - 侧边栏外侧 -->
            <el-tooltip
              :content="$t('layout.layout.free_credits')"
              :disabled="inviteMenuVisible"
              effect="dark"
              placement="right"
            >
              <div
                ref="inviteMenuTrigger"
                class="invite-reward-entry"
                :role="touchNavigation ? 'button' : null"
                :tabindex="touchNavigation ? 0 : -1"
                :aria-label="$t('layout.layout.free_credits')"
                :aria-expanded="touchNavigation ? inviteMenuVisible : null"
                aria-controls="layout-invite-menu"
                @click.stop="toggleInviteMenu"
                @keydown.enter.prevent="touchNavigation && toggleInviteMenu($event)"
                @keydown.space.prevent="touchNavigation && toggleInviteMenu($event)"
              >
                <div class="invite-reward-box">
                  <el-icon v-if="isMobileViewport" class="invite-reward-icon" aria-hidden="true"><Present /></el-icon>
                  <i v-else class="invite-reward-icon icon ag-iconfont icon-gift-box" aria-hidden="true" />
                </div>
                <span v-if="isMobileViewport" class="mobile-invite-label">{{ $t('layout.layout.free_credits') }}</span>
              </div>
            </el-tooltip>

            <div
              v-if="isLoggedIn"
              ref="userMenuTrigger"
              class="bottom-menu-bar-user"
              :role="touchNavigation ? 'button' : null"
              :tabindex="touchNavigation ? 0 : -1"
              :aria-label="$t('layout.layout.account_settings')"
              :aria-expanded="touchNavigation ? userMenuVisible : null"
              aria-controls="layout-user-menu"
              @click.stop="toggleUserMenu"
              @keydown.enter.prevent="touchNavigation && toggleUserMenu($event)"
              @keydown.space.prevent="touchNavigation && toggleUserMenu($event)"
            >
              <div class="user-content-box">
                <div class="mobile-sidebar-icon sidebar-avatar-slot">
                  <UserAvatarBadge
                    :size="isMobileViewport ? 24 : 25"
                    :src="$store.getters['user/avatar'] || require('@/assets/img/def_user.png')"
                    :subscription-key="$store.getters['user/user_sub']"
                  />
                </div>
                <span
                  v-if="!menuCollapse || isMobileViewport"
                  class="user-info-nick_nam"
                >{{ $store.getters['user/nick_name'] }}</span>
              </div>
            </div>
            <el-button
              v-else
              class="guest-login-button"
              @click.stop="openLogin"
            >
              {{ $t('views.login.login_button') }}
            </el-button>

            <teleport to="body">
              <transition name="account-sheet">
              <div
                id="layout-user-menu"
                ref="userMenuPanel"
                v-show="isLoggedIn && userMenuVisible"
                class="custom-user-menu-container"
                tabindex="-1"
                @scroll.capture.passive="handleSidebarMenuScroll"
                :style="userMenuPosition"
                :role="isMobileViewport ? 'dialog' : null"
                :aria-modal="isMobileViewport ? 'true' : null"
                :aria-label="isMobileViewport ? $t('layout.layout.account_settings') : null"
                @click.stop
              >
                <div class="user-opt-box">
                  <!-- 用户信息头部 -->
                  <div class="user-info-header">
                    <UserAvatarBadge
                      :size="36"
                      :src="$store.getters['user/avatar'] || require('@/assets/img/def_user.png')"
                      :subscription-key="$store.getters['user/user_sub']"
                    />
                    <div class="user-info-details">
                      <div class="username">{{ $store.getters['user/nick_name'] }}</div>
                      <el-tooltip
                        v-if="isEmailOverflow"
                        :content="$store.getters['email']"
                        effect="dark"
                        placement="bottom-end"
                      >
                        <div class="email">{{ truncatedEmail }}</div>
                      </el-tooltip>
                      <div v-else class="email">{{ truncatedEmail }}</div>
                    </div>
                    <el-button
                      v-if="canManageSubscription"
                      class="subscription-btn"
                      type="primary"
                      size="small"
                      @click="openSubPage"
                    >
                      {{ $t('layout.layout.upgrade') }}
                    </el-button>
                  </div>

                  <div class="current-plan-card">
                    <div class="current-plan-points">
                      <div>
                        <div
                            v-if="currentTeamVersionName"
                            class="current-plan-version"
                            :title="currentTeamVersionName"
                        >
                          {{ currentTeamVersionName }}
                        </div>
                      </div>
                      <div>
                        <i class="icon ag-iconfont icon-integral-diamond "/> <strong>{{ displayPoints }}</strong>
                      </div>
                    </div>
                  </div>

                  <button
                    ref="teamMenuTrigger"
                    class="current-team-trigger"
                    type="button"
                    aria-haspopup="menu"
                    :aria-expanded="teamMenuVisible"
                    aria-controls="layout-team-menu"
                    :title="currentTeamDisplayName"
                    @click.stop="toggleTeamMenu"
                  >
                    <span class="current-team-trigger-icon" aria-hidden="true">
                       <img
                           v-if="currTeam&&currTeam.avatar&&Number(currTeam.team_type)<1"
                           class="current-team-trigger-avatar"
                           :src="currTeam.avatar"
                           alt=""
                       >
                      <i v-else  class="icon ag-iconfont" :class="currentTeamIconClass" />
                    </span>
                    <span class="current-team-trigger-name">{{ currentTeamDisplayName }}</span>
                    <el-icon class="current-team-trigger-arrow"><ArrowRight /></el-icon>
                  </button>

                  <div class="custom-menu" @click="teamMenuVisible = false">
                    <div
                      v-if="canManageCurrentTeam"
                      class="menu-item"
                      :role="touchNavigation ? 'button' : null"
                      :tabindex="touchNavigation ? 0 : null"
                      @click="openTeamManagement"
                      @keydown.enter.prevent="touchNavigation && openTeamManagement()"
                      @keydown.space.prevent="touchNavigation && openTeamManagement()"
                    >
                      <i class="menu-icon icon ag-iconfont icon-company" aria-hidden="true" />
                      <span>{{ $t('layout.layout.team_management') }}</span>
                    </div>
                    <div
                        v-if="currTeam&&currTeam.team_type>0"
                        class="menu-item"
                        :role="touchNavigation ? 'button' : null"
                        :tabindex="touchNavigation ? 0 : null"
                        @click="showDialogJoinTeam"
                        @keydown.enter.prevent="touchNavigation && showDialogJoinTeam()"
                        @keydown.space.prevent="touchNavigation && showDialogJoinTeam()"
                    >
                      <i class="menu-icon icon ag-iconfont icon-user-add" aria-hidden="true" />
                      <span>{{ $t('layout.layout.join_team') }}</span>
                    </div>
                    <!-- 离开团队暂时不开发此功能，只有管理可以移除团队成员-->
<!--                    <div
                      v-if="canLeaveCurrentTeam"
                      class="menu-item danger-menu-item"
                      @click="confirmLeaveCurrentTeam"
                    >
                      <i class="menu-icon icon ag-iconfont icon-back" aria-hidden="true" />
                      <span>{{ $t('layout.layout.leave_team') }}</span>
                    </div>-->

                    <!-- 账号设置 -->
                    <div
                      ref="userMenuFirstAction"
                      class="menu-item"
                      :role="touchNavigation ? 'button' : null"
                      :tabindex="touchNavigation ? 0 : null"
                      @click="openAccountCenter"
                      @keydown.enter.prevent="touchNavigation && openAccountCenter()"
                      @keydown.space.prevent="touchNavigation && openAccountCenter()"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="account"
                      />
                      <span>{{ $t("layout.layout.account_settings") }}</span>
                    </div>

                    <div
                      class="menu-item"
                      :role="touchNavigation ? 'button' : null"
                      :tabindex="touchNavigation ? 0 : null"
                      @click="openSubscriptionCenter"
                      @keydown.enter.prevent="touchNavigation && openSubscriptionCenter()"
                      @keydown.space.prevent="touchNavigation && openSubscriptionCenter()"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="crown"
                      />
                      <span>{{ $t("layout.layout.my_sub") }}</span>
                    </div>



                    <!-- 语言设置 -->
                    <div
                      ref="languageMenuRef"
                      class="menu-item"
                      :role="touchNavigation ? 'button' : null"
                      :tabindex="touchNavigation ? 0 : null"
                      @click.stop="toggleLanguagePopover($event)"
                      @keydown.enter.prevent.stop="touchNavigation && toggleLanguagePopover($event)"
                      @keydown.space.prevent.stop="touchNavigation && toggleLanguagePopover($event)"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="language"
                      />
                      <span>{{ $t("layout.layout.language") }}</span>
                      <span class="current-lang">{{ currentLanguage.name }}</span>
                      <el-icon><ArrowRight /></el-icon>
                    </div>

                    <!-- 主题设置 -->
                    <div class="theme-setting-row">
                    <div class="menu-item">
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="theme"
                      />
                      <span>{{ $t("layout.layout.theme") }}</span>
                    </div>
                    <div class="theme-options-wrapper">
                      <el-radio-group
                        v-model="themeValue"
                        size="small"
                        @change="themeValueChange"
                      >
                        <el-radio
                          v-for="item in themeOptions"
                          :key="item.id"
                          :value="item.key"
                        >
                          {{ item.name }}
                        </el-radio>
                      </el-radio-group>
                    </div>
                    </div>

                    <!-- 退出登录 -->
                    <div
                      class="menu-item"
                      :role="touchNavigation ? 'button' : null"
                      :tabindex="touchNavigation ? 0 : null"
                      @click="userLogout"
                      @keydown.enter.prevent="touchNavigation && userLogout()"
                      @keydown.space.prevent="touchNavigation && userLogout()"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="logout"
                      />
                      <span>{{ $t("layout.layout.logout") }}</span>
                    </div>
                  </div>
                </div>
              </div>
              </transition>
            </teleport>

            <teleport to="body">
              <div
                id="layout-team-menu"
                ref="teamMenuPanel"
                v-show="isLoggedIn && userMenuVisible && teamMenuVisible"
                class="team-switch-popover"
                :style="teamMenuPosition"
                role="menu"
                :aria-label="$t('layout.layout.current_team')"
                @click.stop
                @keydown.esc.prevent.stop="closeTeamMenu(true)"
              >
                <div v-if="orderedTeamSwitchItems.length" class="team-switch-popover-list">
                  <button
                    v-for="teamItem in orderedTeamSwitchItems"
                    :key="teamItem.team_id"
                    class="team-switch-popover-item"
                    :class="{
                      'is-current': isCurrentTeam(teamItem),
                      'is-switching': teamSwitchingId !== null && Number(teamSwitchingId) === Number(teamItem.team_id)
                    }"
                    type="button"
                    role="menuitemradio"
                    :aria-checked="isCurrentTeam(teamItem)"
                    :disabled="teamSwitchingId !== null"
                    :title="getTeamDisplayName(teamItem)"
                    @click="switchUserCurrIdentity(teamItem.team_id)"
                  >
                    <span class="team-switch-popover-icon" aria-hidden="true">
                      <img
                        v-if="teamItem.avatar"
                        class="team-switch-popover-avatar"
                        :src="teamItem.avatar"
                        alt=""
                      >
                      <i v-else class="icon ag-iconfont" :class="getTeamIconClass(teamItem)" />
                    </span>
                    <span class="team-switch-popover-name">{{ getTeamDisplayName(teamItem) }}</span>
                    <i
                      v-if="isCurrentTeam(teamItem)"
                      class="team-switch-popover-check icon ag-iconfont icon-true"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <div class="team-switch-popover-footer">
                  <button
                    class="team-switch-popover-create"
                    type="button"
                    role="menuitem"
                    :disabled="teamSwitchingId !== null"
                    @click="showDialogCreateTeam"
                  >
                    <span class="team-switch-popover-icon" aria-hidden="true">
                      <i class="icon ag-iconfont icon-add_plus" />
                    </span>
                    <span>{{ $t('layout.layout.create_team') }}</span>
                  </button>
                </div>
              </div>
            </teleport>

            <!-- 语言弹窗 -->
            <teleport to="body">
              <div
                v-show="languagePopoverVisible"
                class="language-popover-container"
                :style="languageMenuPosition"
                @click.stop
              >
                <div class="language-options">
                  <div class="language-options-wrapper">
                    <el-radio-group
                      v-model="languageValue"
                      size="default"
                      @change="languageValueChange"
                    >
                      <el-radio
                        v-for="item in languageOptions"
                        :key="item.id"
                        :value="item.key"
                      >
                        {{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </teleport>
            <div
                v-if="!showGuestFilingInfo"
                ref="contactInfoTrigger"
                class="contact-info-entry"
                tabindex="0"
                role="button"
                :aria-label="$t('layout.layout.more')"
                aria-controls="layout-contact-menu"
                :aria-expanded="contactInfoVisible"
                @mouseenter="!isMobileViewport && showContactMenu()"
                @mouseleave="!isMobileViewport && scheduleHideContactMenu()"
                @focus="!isMobileViewport && showContactMenu()"
                @blur="!isMobileViewport && scheduleHideContactMenu()"
                @click.stop.prevent="showContactMenu"
                @keydown.enter.prevent.stop="showContactMenu"
                @keydown.space.prevent.stop="showContactMenu"
            >
              <div class="contact-info-box">
                <el-icon v-if="isMobileViewport" class="contact-info-icon" aria-hidden="true"><More /></el-icon>
                <i v-else class="icon ag-iconfont icon-more-horizontal contact-info-icon" aria-hidden="true" />
                <span
                    v-if="!menuCollapse || isMobileViewport"
                    class="contact-info-label"
                >{{ $t('layout.layout.more') }}</span>
              </div>
            </div>
            <teleport to="body" :disabled="showGuestFilingInfo">
              <div
                v-show="showGuestFilingInfo || contactInfoVisible"
                id="layout-contact-menu"
                ref="contactMenuPanel"
                class="contact-menu-popover"
                :class="{ 'guest-filing-info': showGuestFilingInfo }"
                :style="showGuestFilingInfo ? undefined : contactInfoPosition"
                @mouseenter="!isMobileViewport && cancelHideContactMenu()"
                @mouseleave="!isMobileViewport && scheduleHideContactMenu()"
                @click.stop
              >
                <div v-if="!showGuestFilingInfo" class="contact-menu-list">
                  <div
                      v-for="item in contactMenuItems"
                      :key="item.key"
                      class="contact-menu-item"
                      :class="{ 'is-contact-item': item.key === 'contact', 'is-external-item': !!item.url }"
                      :tabindex="item.key === 'contact' || item.url ? 0 : -1"
                      :role="item.key === 'contact' || item.url ? 'button' : undefined"
                      @keydown.enter.prevent="openContactMenuItem(item)"
                      @keydown.space.prevent="openContactMenuItem(item)"
                      @click="openContactMenuItem(item)"
                  >
                    <span>{{ item.label }}</span>
                  </div>
                </div>
                <div v-if="!showGuestFilingInfo" class="contact-menu-divider" />
                <div class="contact-menu-records">
                  <a
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      rel="noopener noreferrer"

                  >闽ICP备2026022474号-2</a>
                  <a
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302037392"
                      target="_blank"
                      style="display: flex;gap: 4px;"
                      rel="noopener noreferrer"
                  ><img src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" class="w-full" style="width: 14px; height: 14px;">闽公网安备35020302037392号</a>
                  <div class="contact-menu-caption">
                    厦门智道开物科技有限公司
                  </div>
                </div>
              </div>
            </teleport>
            <hr class="divider">
          </div>
        </div>
      </el-aside>
      <div
        v-if="navigationOverlayActive && (mobileDrawerOpen || userMenuVisible)"
        class="mobile-drawer-backdrop"
        aria-hidden="true"
        @click="userMenuVisible ? toggleUserMenu($event) : closeMobileDrawer()"
      />
      <header
        v-show="!mobileTopBarHidden"
        class="mobile-topbar"
        :class="{ 'mobile-topbar--centered-title': mobileTopBarTitleCentered }"
        :inert="mobileDrawerOpen || (isMobileViewport && userMenuVisible) ? '' : null"
      >
        <!-- 按 mobileTopBarParts 稳定 key 重排节点：DOM 顺序即视觉与 Tab 顺序；
             菜单按钮与动作宿主在 back 切换时仅移动，不复制、不重建。 -->
        <template
          v-for="part in mobileTopBarParts"
          :key="part"
        >
          <button
            v-if="part === 'back'"
            type="button"
            class="mobile-shell-button mobile-topbar-back"
            :aria-label="mobileBackConfig.label"
            :disabled="mobileBackConfig.disabled"
            @click="handleMobileBackClick"
          >
            <el-icon aria-hidden="true"><ArrowLeft /></el-icon>
          </button>
          <button
            v-else-if="part === 'menu'"
            :ref="setMobileNavigationTrigger"
            type="button"
            class="mobile-shell-button mobile-topbar-menu"
            :aria-label="$t('layout.layout.open_navigation')"
            :aria-expanded="mobileDrawerOpen"
            aria-controls="layout-navigation"
            @click="openMobileDrawer"
          >
            <i class="icon ag-iconfont icon-left-bar" aria-hidden="true" />
          </button>
          <span
            v-else-if="part === 'title'"
            class="mobile-topbar-brand"
            :title="mobileTopBarTitle"
          >{{ mobileTopBarTitle }}</span>
          <div
            v-else-if="part === 'actions'"
            :ref="setMobileActionsTarget"
            class="mobile-topbar-actions"
          />
        </template>
      </header>
      <el-main
        ref="layoutMain"
        class="layout-container-main"
        :class="{ 'mobile-page-scroll-owner': mobilePageOwnsScroll }"
        :inert="mobileDrawerOpen || (isMobileViewport && userMenuVisible) ? '' : null"
        tabindex="-1"
      >
        <router-view v-slot="{ Component }">
          <transition
            mode="out-in"
            name="move"
          >
            <component
              :is="Component"
              @changeNav="changeNav"
            />
          </transition>
        </router-view>
      </el-main>
    </el-container>

    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="contactDialogVisible"
      class="contact-dialog"
      :width="isMobileViewport ? undefined : '400px'"
      :size="isMobileViewport ? 'min(92vh, 720px)' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      append-to-body
      :show-close="true"
      :close-on-click-modal="true"
      title="联系我们"
    >
      <div class="contact-dialog-content">
        <div class="contact-dialog-section">
          <div class="contact-dialog-caption">版权所有</div>
          <div class="contact-dialog-value">厦门智道开物科技有限公司</div>
        </div>

        <div class="contact-dialog-section contact-dialog-wechat">
          <div class="contact-dialog-caption">客服微信</div>
          <AppPreviewImage
            class="contact-dialog-qrcode"
            fit="contain"
            :src="require('@/assets/img/contact_qrcode.jpg')"
            :preview-src-list="[require('@/assets/img/contact_qrcode.jpg')]"
          />
        </div>

        <div class="contact-dialog-section">
          <div class="contact-dialog-caption">电子邮箱</div>
          <a
            class="contact-dialog-link"
            href="mailto:marketing@paiteams.com"
          >marketing@paiteams.com</a>
        </div>

      </div>
    </component>

    <EnterpriseContactDialog
      v-model="enterpriseContactDialogVisible"
      :mobile="isMobileViewport"
      @closed="handleEnterpriseContactClosed"
    />

    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogTeamInvitation"
      class="team-entry-dialog"
      :before-close="done => { if (!teamInvitationBusy) done() }"
      :close-on-click-modal="false"
      :width="isMobileViewport ? undefined : '800px'"
      :size="isMobileViewport ? '100%' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      :title="$t('layout.layout.team_invitation')"
      append-to-body
    >
      <div class="team-invitation-box">
        <TeamInvitation
          v-if="dialogTeamInvitation"
          ref="teamInvitationDlg"
          :is-dialog="true"
          @busy-change="teamInvitationBusy = $event"
          @confirm-end="confirmTeamInvitation"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button
            type="primary"
            :loading="teamInvitationBusy"
            @click="submitTeamInvitation()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </component>

    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogCreateTeam"
      class="team-entry-dialog"
      :before-close="done => { if (!createTeamBusy) done() }"
      :close-on-click-modal="false"
      :width="isMobileViewport ? undefined : '500px'"
      :size="isMobileViewport ? '100%' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      :title="$t('layout.layout.create_team')"
      append-to-body
    >
      <div class="createTeamBox">
        <CreateTeam
          v-if="dialogCreateTeam"
          ref="createTeamDlg"
          :is-dialog="true"
          @busy-change="createTeamBusy = $event"
          @update-team="updateTeam"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button :disabled="createTeamBusy" @click="closeDialogCreateTeam()">{{ $t("common.cancel") }}</el-button>
          <el-button
            type="primary"
            :loading="createTeamBusy"
            @click="submitCreateTeam()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </component>

    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogJoinTeam"
      class="team-entry-dialog join-team-dialog"
      :before-close="done => { if (!joinTeamBusy) done() }"
      :close-on-click-modal="false"
      :align-center="isMobileViewport"
      :width="isMobileViewport ? undefined : '500px'"
      :size="isMobileViewport ? 'min(92vh, 760px)' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      :title="$t('layout.layout.join_team')"
      append-to-body
    >
      <div class="joinTeamBox">
        <CodeJoinTeam
          v-if="dialogJoinTeam"
          ref="joinTeamDlg"
          :is-dialog="true"
          @busy-change="joinTeamBusy = $event"
          @update-team="updateTeam"
          @close-dlg="dialogJoinTeam = false"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button :disabled="joinTeamBusy" @click="closeDialogJoinTeam()">{{ $t("common.cancel") }}</el-button>
          <el-button
            type="primary"
            :loading="joinTeamBusy"
            @click="submitJoinTeam()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </component>

    <!-- 账号中心弹窗 -->
    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogAccountCenter"
      :show-close="false"
      :append-to-body="isMobileViewport"
      :title="isMobileViewport ? $t('views.account_center.account_center') : ''"
      :width="isMobileViewport ? undefined : '1200px'"
      :size="isMobileViewport ? '100%' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      class="accountCenterBox"
      modal-class="account-center-overlay"
      destroy-on-close
      @close="closeAccountCenter"
      @closed="handleAccountCenterClosed"
    >
      <div class="account-center-container">
        <el-button
          v-if="displayState.isPhone && displayState.layoutMode === 'desktop'"
          class="account-center-landscape-cancel"
          link
          :aria-label="$t('common.close')"
          @click="closeAccountCenter"
        ><el-icon aria-hidden="true"><Close /></el-icon></el-button>
        <AccountCenter
          v-if="dialogAccountCenter"
          :is-i-pad="displayState.isIPad"
          @close="closeAccountCenter"
          @payment-success="accountCenterPaymentSuccess"
        />
      </div>
    </component>

    <!-- 轻量订阅购买弹窗；完整账号中心仍由上面的弹窗承载 -->
    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogSubscriptionPurchase"
      :show-close="false"
      :width="isMobileViewport ? undefined : '1120px'"
      :size="isMobileViewport ? '100%' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      class="subscriptionPurchaseBox"
      append-to-body
      destroy-on-close
      @closed="handleSubscriptionDialogClosed"
    >
      <SubscriptionPurchase
        v-if="dialogSubscriptionPurchase"
        @close="dialogSubscriptionPurchase = false"
        @payment-success="handleSubscriptionPaymentSuccess"
      />
    </component>

    <PaymentSuccessDialog
      v-if="subscriptionPaymentSuccessVisible"
      :need-reload="true"
      :ver-name="subscriptionPaymentSuccessData.ver_name"
      :benefits-list="subscriptionPaymentSuccessData.present_benefits"
      :order-type="subscriptionPaymentSuccessData.order_type"
      :expand-data="subscriptionPaymentSuccessData.expand_data"
      @closePaymentSuccessDlg="closeSubscriptionPaymentSuccess"
    />

    <!-- 邀请奖励弹窗 -->
    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogInviteReward"
      :width="isMobileViewport ? undefined : '420px'"
      :size="isMobileViewport ? 'min(92vh, 760px)' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      :show-close="false"
      class="invite-reward-dialog"
      :class="{ 'is-mobile-invite-dialog': isMobileViewport }"
      :align-center="isMobileViewport"
      append-to-body
      destroy-on-close
      :close-on-press-escape="!isMobileViewport"
      @closed="handleInviteDialogClosed('reward')"
    >
      <InviteDialog v-if="dialogInviteReward" :mobile="isMobileViewport" @close="dialogInviteReward = false" />
    </component>

    <!-- 填写邀请码弹窗 -->
    <component
      :is="isMobileViewport ? 'el-drawer' : 'el-dialog'"
      v-model="dialogBindInviteCode"
      :width="isMobileViewport ? undefined : '420px'"
      :size="isMobileViewport ? 'min(92vh, 760px)' : undefined"
      :direction="isMobileViewport ? 'btt' : undefined"
      :show-close="false"
      class="invite-reward-dialog"
      :class="{ 'is-mobile-invite-dialog': isMobileViewport }"
      :align-center="isMobileViewport"
      append-to-body
      destroy-on-close
      @closed="handleInviteDialogClosed('bind')"
    >
      <BindInviteCodeDialog v-if="dialogBindInviteCode" :mobile="isMobileViewport" @close="dialogBindInviteCode = false" />
    </component>

    <!-- 邀请菜单（推荐朋友 / 填写邀请码） -->
    <teleport to="body">
      <div
        id="layout-invite-menu"
        ref="inviteMenuPanel"
        v-show="inviteMenuVisible"
        class="invite-menu-popover"
        :style="inviteMenuPosition"
        :role="isMobileViewport ? 'dialog' : null"
        :aria-modal="isMobileViewport ? 'true' : null"
        :aria-label="isMobileViewport ? $t('layout.layout.free_credits') : null"
        @click.stop
      >
        <div
          ref="inviteMenuFirstAction"
          class="invite-menu-item"
          :role="touchNavigation ? 'button' : null"
          :tabindex="touchNavigation ? 0 : null"
          @click="openInviteReward"
          @keydown.enter.prevent="touchNavigation && openInviteReward()"
          @keydown.space.prevent="touchNavigation && openInviteReward()"
        >
          <svg class="invite-menu-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 21a8 8 0 0 0-16 0"></path><circle cx="10" cy="8" r="5"></circle><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"></path></svg>
          <span>{{ $t('layout.layout.refer_friend') }}</span>
        </div>
        <div
          class="invite-menu-item"
          :role="touchNavigation ? 'button' : null"
          :tabindex="touchNavigation ? 0 : null"
          @click="openBindInviteCode"
          @keydown.enter.prevent="touchNavigation && openBindInviteCode()"
          @keydown.space.prevent="touchNavigation && openBindInviteCode()"
        >
          <svg-icon class-name="invite-menu-icon" icon-class="invite-code" />
          <span>{{ $t('layout.layout.bind_invite_code') }}</span>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import CreateTeam from '@/views/user_center/components/create_team'
import CodeJoinTeam from '@/views/user_center/components/code_join_team'
import TeamInvitation from '@/views/user_center/components/invitation'
import SubscriptionPurchase from '@/views/account_center/components/subscription_purchase.vue'
import PaymentSuccessDialog from '@/views/account_center/components/payment_success.vue'
import {getPreferenceConfigs, getUserPreference, switchCurrIdentity, updateUserPreference} from '@/api/user'
import { leaveTeam } from '@/api/team'
import {getContactMenuList} from '@/api/contactMenu'
import {computed, getCurrentInstance, ref, shallowRef} from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import EventBus from '@/utils/eventBus'
import AccountCenter from '@/views/account_center/index.vue'
import InviteDialog from '@/components/invite/InviteDialog.vue'
import BindInviteCodeDialog from '@/components/invite/BindInviteCodeDialog.vue'
import EnterpriseContactDialog from '@/components/enterprise/EnterpriseContactDialog.vue'
import i18n, { setLocale, setI18nLanguage, getLocale} from '@/locales/i18n'
import getPageTitle from '@/utils/pageTitle'
import { switchTheme, getTheme, getThemeKeyById } from '@/utils/theme'
import { ArrowLeft, ArrowRight, Bell, Close, House, ChatDotRound, Document, FolderOpened, OfficeBuilding, Trophy, Present, More } from '@element-plus/icons-vue'
import { isAuthenticated, requireAuth } from '@/utils/authGate'
import UserAvatarBadge from '@/components/UserAvatarBadge/index.vue'
import MobileAgentNavigation from '@/views/mobile/layout/components/MobileAgentNavigation.vue'
import MobileSidebarListNavigation from '@/views/mobile/layout/components/MobileSidebarListNavigation.vue'
import { readDisplayState } from '@/views/mobile/shared/displayState'
import { useDisplayState } from '@/views/mobile/shared/useDisplayState'
export default {
  name: 'PcLayout',
  components: {
    ArrowLeft,
    ArrowRight,
    Bell,
    Close,
    House,
    ChatDotRound,
    Document,
    FolderOpened,
    OfficeBuilding,
    Trophy,
    Present,
    More,
    SvgIcon,
    CreateTeam,
    CodeJoinTeam,
    TeamInvitation,
    SubscriptionPurchase,
    PaymentSuccessDialog,
    AccountCenter,
    InviteDialog,
    BindInviteCodeDialog,
    EnterpriseContactDialog,
    UserAvatarBadge,
    MobileAgentNavigation,
    MobileSidebarListNavigation
  },
  provide() {
    return {
      menuCollapse: computed(() => this.menuCollapse),
      toggleMenuCollapse: this.toggleMenuCollapse,
      globalEventBus: this.globalEventBus,
      mobilePageLayout: this.mobilePageLayout
    }
  },
  setup() {
    const { displayState } = useDisplayState()
    const instance = getCurrentInstance()
    const languageMenuRef = ref(null)
    const userMenuTrigger = ref(null)
    const teamMenuTrigger = ref(null)
    const contactInfoTrigger = ref(null)
    const accountCenterReturnFocus = shallowRef(null)
    const accountCenterPreviousFocus = shallowRef(null)
    // mobilePageLayout 本地展示协调状态：组件实例私有引用，不进 data，不新增 EventBus 事件或 Store 状态。
    // 元素引用用 shallowRef 保证 .value 与写入引用同一：内存验证环境以普通对象字面量作节点，其 toRawType
    // 为 Object 落在 reactive 白名单内、会被 ref() 代理成 Proxy 导致身份不等；真实 HTMLElement 的类型标签
    // （如 HTMLDivElement）不在白名单、不被代理，故 shallowRef 对生产 DOM 属防御性推荐写法而非缺陷修复。
    const mobileActionsTarget = shallowRef(null)
    const mobileNavigationTrigger = shallowRef(null)
    const mobileActiveOwner = ref(null)
    const mobileRegistration = shallowRef(null)
    let mobileRegistrationSeq = 0
    let mobileReleaseSeq = 0
    function readMobilePageConfig() {
      const registration = mobileRegistration.value
      if (!registration) return null
      // readConfig 视为只读、无副作用；页面异常只回退默认展示，不做业务补偿或自动导航。
      try {
        return registration.readConfig() || null
      } catch (error) {
        console.warn('[mobilePageLayout] 读取页面展示配置失败:', error)
        return null
      }
    }
    // 每次求值都实时调用 readConfig，追踪页面自身的响应式依赖，保证标题 / 状态变化无需重新注册。
    const mobileActiveConfig = computed(() => (mobileRegistration.value ? readMobilePageConfig() : null))
    const mobilePageLayout = {
      isMobile: computed(() => instance.proxy.isMobileViewport),
      isTablet: computed(() => displayState.value.isIPad),
      layoutTier: computed(() => displayState.value.layoutTier),
      displayState,
      activeOwner: computed(() => mobileActiveOwner.value),
      actionsTarget: computed(() => mobileActionsTarget.value),
      registerPage(owner, readConfig) {
        if (typeof owner !== 'string' || !owner || typeof readConfig !== 'function') return () => {}
        const id = ++mobileRegistrationSeq
        mobileRegistration.value = { id, owner, readConfig }
        mobileActiveOwner.value = owner
        // release 与注册序号绑定：只释放产生它的那次注册，重复调用或过期调用无副作用。
        return () => {
          if (mobileReleaseSeq >= id) return
          mobileReleaseSeq = id
          if (mobileRegistration.value && mobileRegistration.value.id === id) {
            mobileRegistration.value = null
            mobileActiveOwner.value = null
          }
        }
      }
    }
    return {
      displayState,
      languageMenuRef,
      userMenuTrigger,
      teamMenuTrigger,
      contactInfoTrigger,
      accountCenterReturnFocus,
      accountCenterPreviousFocus,
      mobileActionsTarget,
      mobileNavigationTrigger,
      // 顶栏节点位于 keyed v-for 内，字符串 ref 会被编译为 ref_for:true 并收集成数组，
      // 故动作宿主与菜单入口均用函数 ref 绑定单一节点，保证 actionsTarget 非数组且菜单可直接 focus。
      setMobileActionsTarget(el) {
        mobileActionsTarget.value = el || null
      },
      setMobileNavigationTrigger(el) {
        mobileNavigationTrigger.value = el || null
      },
      mobileActiveOwner,
      mobileActiveConfig,
      mobilePageLayout,
      cleanupMobilePageLayout() {
        mobileRegistration.value = null
        mobileActiveOwner.value = null
        mobileActionsTarget.value = null
        mobileNavigationTrigger.value = null
        mobileReleaseSeq = mobileRegistrationSeq
      }
    }
  },
  data() {
    const display = readDisplayState()
    return {
      menuActiveIndex: '1',
      menuCollapse: true,
      isMobileViewport: display.layoutMode === 'mobile',
      mobileDrawerOpen: false,
      mobileDrawerReturnFocus: null,
      mobileDrawerNavigationId: null,
      curPath: '/home',
      hidePopover: false,
      dialogCreateTeam: false,
      globalEventBus: EventBus,
      dialogTeamInvitation: false,
      dialogJoinTeam: false,
      createTeamBusy: false,
      joinTeamBusy: false,
      teamInvitationBusy: false,
      userMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: '50px',
        right: 'auto'
      },
      teamMenuVisible: false,
      teamMenuPosition: {
        top: '0px',
        left: '0px',
        bottom: 'auto',
        right: 'auto'
      },
      teamSwitchingId: null,
      languageMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: '50px',
        right: 'auto'
      },
      userMenuVisible: false,
      contactInfoVisible: false,
      contactMenuHideTimer: null,
      contactDialogVisible: false,
      enterpriseContactDialogVisible: false,
      enterpriseContactReturnFocus: null,
      contactMenuRecords: [],
      contactInfoPosition: {
        top: '12px',
        left: '0px',
        right: 'auto',
        bottom: 'auto'
      },
      dialogAccountCenter: false,
      dialogSubscriptionPurchase: false,
      subscriptionPaymentSuccessVisible: false,
      pendingSubscriptionPaymentSuccess: null,
      subscriptionPaymentSuccessData: {
        ver_name: '',
        present_benefits: [],
        order_type: 1,
        expand_data: {
          package_name: '',
          description: ''
        }
      },
      dialogInviteReward: false,
      dialogBindInviteCode: false,
      inviteMenuVisible: false,
      inviteDialogReturnFocus: null,
      inviteDialogFocusSeq: 0,
      inviteMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: 'auto',
        right: 'auto'
      },
      languagePopoverVisible: false,
      languageValue: 'zh-cn',
      themeValue: 'system',
      themeOptions: [
      ],
      languageOptions: [],
      currentLanguage: {'key': '', name: ''},
      isDomestic: process.env.VUE_APP_LEGAL_REGION === 'domestic'
    }
  },
  computed: {
    showGuestFilingInfo() {
      return this.isDomestic && this.isMobileViewport && !this.isLoggedIn
    },
    touchNavigation() { return this.isMobileViewport || this.displayState.isIPad },
    navigationOverlayActive() {
      return this.isMobileViewport
    },
    sidebarMenus() {
      return this.menus
    },
    mobileNavigationAgentCategory() {
      if (this.$route.name === 'WebGeneration') return 'engineering_web_developer'
      if (this.$route.matched.some(route => route.name === 'ImageGeneration')) return 'image_generation_agent'
      return ''
    },
    mobileProjectNavigationItems() {
      const projects = this.$store.getters['mobileNavigation/projectList'] || []
      return projects.filter(project => project?.def_doc_uniq_code || project?.uniq_code).map(project => ({
        ...project,
        navigationKey: project.def_doc_uniq_code || project.uniq_code
      }))
    },
    mobileProjectActiveKey() {
      return String(this.$route.params.doc_uniq_code || this.$route.params.uniq_code || '')
    },
    mobileProjectOverviewActive() {
      return this.$route.path === '/projects'
    },
    mobileAssetNavigationItems() {
      const rootFolder = this.$store.getters['mobileNavigation/assetRootFolder'] || {}
      const folders = this.$store.getters['mobileNavigation/assetFolders'] || []
      return [
        { code: 'default', name: this.$t('views.attachment.default_space'), navigationKey: 'default' },
        ...folders
          .filter(folder => folder && typeof folder === 'object' && folder.code !== undefined && folder.code !== null && String(folder.code).trim())
          .map(folder => ({ ...folder, navigationKey: String(folder.code) }))
      ].map(item => item.code === 'default' ? { ...item, file_count: rootFolder.file_count || 0 } : item)
    },
    mobileAssetActiveKey() {
      return String(this.$route.params.folder_code || '')
    },
    mobileAssetOverviewActive() {
      return this.$route.path === '/assets'
    },
    mobileTopBarTitle() {
      if (this.mobileActiveConfig?.hideTitle === true) return ''
      const title = this.mobileActiveConfig?.title
      return typeof title === 'string' && title.trim() ? title.trim() : ''
    },
    mobileTopBarTitleCentered() {
      return this.mobileActiveConfig?.titleAlign === 'center' && !this.mobileBackConfig
    },
    mobileBackConfig() {
      const back = this.mobileActiveConfig?.back
      if (!back || typeof back.onClick !== 'function') return null
      const label = typeof back.label === 'string' && back.label.trim() ? back.label.trim() : this.$t('layout.layout.back')
      return { label, onClick: back.onClick, disabled: back.disabled === true }
    },
    mobileScrollOwner() {
      return this.mobileActiveConfig?.scrollOwner === 'page' ? 'page' : 'layout'
    },
    mobileOverlayOpen() {
      return Boolean(this.mobileActiveConfig?.overlayOpen)
    },
    mobileTopBarHidden() {
      return this.isMobileViewport && !!this.mobileActiveOwner && this.mobileActiveConfig?.hideTopBar === true
    },
    mobileTopBarOverlaysContent() {
      return this.mobilePageOwnsScroll && !this.mobileTopBarHidden && this.mobileActiveConfig?.overlayTopBar === true
    },
    mobilePageOwnsScroll() {
      return this.isMobileViewport && !!this.mobileActiveOwner && this.mobileScrollOwner === 'page'
    },
    mobileTopBarParts() {
      // DOM 顺序即视觉与 Tab 顺序：无 back 时菜单→标题→操作；有 back 时返回→标题→操作→菜单。
      return this.mobileBackConfig
        ? ['back', 'title', 'actions', 'menu']
        : ['menu', 'title', 'actions']
    },
    blockingDialogVisible() {
      return this.$store.getters['authDialog/visible'] || this.enterpriseContactDialogVisible ||
        this.contactDialogVisible || this.dialogAccountCenter || this.dialogSubscriptionPurchase ||
        this.dialogInviteReward || this.dialogBindInviteCode || this.dialogCreateTeam ||
        this.dialogJoinTeam || this.dialogTeamInvitation || this.subscriptionPaymentSuccessVisible
    },
    isLoggedIn() {
      return Boolean(this.$store.getters['user/accessToken']) && isAuthenticated()
    },
    currentTeamId() {
      return this.$store.getters['user/current_team_id']
    },
    currentUserId() {
      return this.$store.getters.user_id
    },
    mobileAgentNavigationResult() {
      return this.$store.getters['chat/mobileAgentNavigationResult']
    },
    currTeam() {
      const loadedTeam = this.$store.getters['team/currentTeam'] || {}
      if (loadedTeam.team_id) return loadedTeam
      const userTeam = this.$store.getters['user/current_team'] || {}
      return {
        ...userTeam,
        team_id: userTeam.team_id || userTeam.id,
        team_roles: userTeam.team_roles || []
      }
    },
    currentTeamDetail() {
      return this.$store.getters['team/currentTeamInfo'] || {}
    },
    memberPointsLimit() {
      return this.$store.getters['team/memberPointsLimit'] || {}
    },
    personTeam() {
      return this.$store.getters['team/personalTeam'] || {}
    },
    userTeamList() {
      return this.$store.getters['team/enterpriseTeams'] || []
    },
    teamSwitchItems() {
      return this.$store.getters['team/teams'] || []
    },
    orderedTeamSwitchItems() {
      return this.teamSwitchItems
        .map((team, index) => ({ team, index }))
        .sort((left, right) => {
          const leftPersonal = Number(left.team.team_type) > 0 ? 0 : 1
          const rightPersonal = Number(right.team.team_type) > 0 ? 0 : 1
          return leftPersonal - rightPersonal || left.index - right.index
        })
        .map(item => item.team)
    },
    currentTeamDisplayName() {
      if (Number(this.currTeam.team_type) > 0) {
        return this.$store.getters['user/nick_name'] ||
          this.currTeam.name ||
          this.$t('layout.layout.personal_team')
      }
      return this.currTeam.name || this.$t('layout.layout.current_team')
    },
    currentTeamIconClass() {
      return Number(this.currTeam.team_type) > 0 ? 'icon-user' : 'icon-company'
    },
    teamPointsSurplus() {
      const numericalAuth = this.currentTeamDetail.numerical_auth || {}
      const pointsQuota = numericalAuth.points_quota || numericalAuth
      return Number(pointsQuota.points_quota_surplus_numerical) || 0
    },
    displayPoints() {
      return this.$store.getters['team/displayPoints'] || 0
    },
    currentTeamVersionName() {
      return this.currentTeamDetail.ver_name ||
        (this.$store.getters['user/current_team_ver'] || {}).ver_name || ''
    },
    canManageCurrentTeam() {
      return this.$store.getters['team/canManage']
    },
    canManageSubscription() {
      return this.$store.getters['team/canManageSubscription'] === true
    },
    isCurrentTeamOwner() {
      if (Object.prototype.hasOwnProperty.call(this.currTeam, 'is_owner')) {
        return Number(this.currTeam.is_owner) === 1 || this.currTeam.is_owner === true
      }
      return Number(this.currTeam.belong_user_id) > 0 &&
        Number(this.currTeam.belong_user_id) === Number(this.$store.getters['user/user_id'])
    },
    canLeaveCurrentTeam() {
      return this.$store.getters['team/isEnterprise'] && !this.isCurrentTeamOwner
    },
    menus() {
      return [
        {
          code: '1',
          name: 'Home',
          show: true,
          icon: 'home-o',
          navigationIcon: 'House',
          activeIcon: 'home-full',
          title: this.$t('layout.layout.home'),
          path: '/home',
          children: []
        },
        {
          code: '2',
          name: 'ChatCreation',
          show: true,
          icon: 'still_more',
          navigationIcon: 'ChatDotRound',
          activeIcon: 'still_more_full',
          title: this.$t('layout.layout.conversation'),
          path: '/chat',
          children: []
        },
        {
          code: '3',
          name: 'Wiki',
          show: true,
          icon: 'questionnaire_whit',
          navigationIcon: 'Document',
          activeIcon: 'questionnaire_full',
          title: this.$t('layout.layout.projects'),
          path: '/projects',
          children: []
        },
        {
          code: '4',
          name: 'Assets',
          show: true,
          icon: 'folder-line',
          navigationIcon: 'FolderOpened',
          iconType: 'iconfont',
          title: this.$t('layout.layout.assets'),
          path: '/assets',
          children: []
        }
      ]
    },
    contactMenuItems() {
      const locale = String(this.languageValue || getLocale() || 'zh-cn').toLowerCase().replace('_', '-')
      const fieldMap = {
        'zh-cn': 'name_zh_cn',
        'zh-tw': 'name_zh_tw',
        'en-us': 'name_en_us'
      }
      const contactLabelMap = {
        'zh-cn': '联系我们',
        'zh-tw': '聯繫我們',
        'en-us': 'Contact us'
      }
      const field = fieldMap[locale] || 'name_zh_cn'
      const records = (this.contactMenuRecords || []).map(item => ({
        key: 'contact-menu-' + item.id,
        label: item[field] || item.name_zh_cn || item.name_zh_tw || item.name_en_us,
        url: item.url
      })).filter(item => item.label && item.url)
      return records.concat([{
        key: 'contact',
        label: contactLabelMap[locale] || contactLabelMap['zh-cn']
      }])
    },
    Bell() {
      return Bell
    },
    truncatedEmail() {
      const email = this.$store.getters['email'] || ''
      const maxBytes = 60 // 设置最大字节数

      if (this.$common.strLen(email) > maxBytes) {
        // 使用 cutByte 方法进行截断
        return this.$common.cutByte(email, maxBytes, '...')
      }
      return email
    },
    isEmailOverflow() {
      const email = this.$store.getters['email'] || ''
      return this.$common.strLen(email) > 20
    }
  },
  watch: {
    displayState() {
      this.updateMobileViewport()
    },
    '$route.fullPath'(currentPath, previousPath) {
      const pending = this.$store.getters['chat/mobileAgentNavigation']
      const enteringChat = this.$router.resolve(currentPath).path === '/chat' &&
        previousPath && this.$router.resolve(previousPath).path !== '/chat'
      const preserveNavigation = enteringChat && pending?.id === this.mobileDrawerNavigationId
      this.closeMobileDrawer(true, !preserveNavigation)
      this.clearSidebarPopovers()
    },
    mobileAgentNavigationResult(result) {
      if (result?.accepted && result.id === this.mobileDrawerNavigationId) {
        this.closeMobileDrawer(false, false)
      }
    },
    currentTeamId() {
      this.clearMobileAgentNavigation()
      this.$store.dispatch('mobileNavigation/reset')
    },
    currentUserId() {
      this.clearMobileAgentNavigation()
      this.$store.dispatch('mobileNavigation/reset')
    },
    blockingDialogVisible(visible) {
      // 弹窗接管焦点时只收起导航，避免焦点恢复打断登录或现有弹窗。
      if (visible) this.closeMobileDrawer(false)
    },
    mobileOverlayOpen(open) {
      // 页面自有弹窗打开时只收起公共浮层，不恢复触发点、不抢弹窗焦点；弹窗关闭由页面自己负责。
      if (open && this.touchNavigation) {
        this.closeMobileDrawer(false)
        this.clearSidebarPopovers()
      }
    },
    menuCollapse: {
      immediate: true,
      handler(val) {
        document.documentElement.style.setProperty('--highlight-left', val ? '3px' : '-15px')
      }
    },
    '$route.path': {
      immediate: true,
      handler(newPath) {
        this.updateActiveMenu(newPath)
      }
    },
    userMenuVisible(value) {
      if (!value) this.closeTeamMenu()
    },
    showGuestFilingInfo() {
      this.cancelHideContactMenu()
      this.contactInfoVisible = false
    },
    isLoggedIn(isLoggedIn, wasLoggedIn) {
      if (isLoggedIn !== wasLoggedIn) this.$store.dispatch('mobileNavigation/reset')
      if (isLoggedIn && !wasLoggedIn) {
        this.getUserTeam()
        return
      }
      if (!isLoggedIn && wasLoggedIn) {
        this.clearMobileAgentNavigation()
        this.$store.dispatch('team/reset')
        this.userMenuVisible = false
        this.inviteMenuVisible = false
        this.dialogAccountCenter = false
        this.dialogSubscriptionPurchase = false
        this.dialogInviteReward = false
        this.dialogBindInviteCode = false
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleMobileDrawerKeydown)
    this.languageValue = getLocale()
    this.loadContactMenuItems()
    this.themeValue = getTheme() // 初始化主题值
    let path = this.$router.currentRoute.value.path
    if (path.indexOf('/chat') >= 0) {
      path = '/chat'
    }
    this.updateActiveMenu(path)
    this.removeNavigationAfterEach = this.$router.afterEach((to, from, failure) => {
      if (!failure) this.updateActiveMenu(to.path)
    })
    document.addEventListener('click', this.handleGlobalClick)
    window.addEventListener('resize', this.handleTeamMenuViewportChange)
    window.visualViewport?.addEventListener('resize', this.handleMobileVisualViewportChange)
    window.visualViewport?.addEventListener('scroll', this.handleMobileVisualViewportChange)
    const menu = this.menus.find(o => o.path === path)
    if (menu) {
      this.menuActiveIndex = menu.code
    }
    this.curPath = path
    if (this.isLoggedIn) {
      this.getUserTeam()
    }

    this.$nextTick(() => {
      this.languageMenuRef = document.querySelector('.language-menu-trigger')
    })
    
    // 监听来自其他组件的打开订阅页面事件
    this.globalEventBus.on('openSubscriptionPage', this.openSubPage)
  },
  beforeUnmount() {
    this.removeNavigationAfterEach?.()
    document.removeEventListener('keydown', this.handleMobileDrawerKeydown)
    this.mobileDrawerReturnFocus = null
    this.inviteDialogReturnFocus = null
    this.inviteDialogFocusSeq += 1
    this.accountCenterReturnFocus = null
    this.accountCenterPreviousFocus = null
    document.removeEventListener('click', this.handleGlobalClick)
    window.removeEventListener('resize', this.handleTeamMenuViewportChange)
    window.visualViewport?.removeEventListener('resize', this.handleMobileVisualViewportChange)
    window.visualViewport?.removeEventListener('scroll', this.handleMobileVisualViewportChange)
    this.cancelHideContactMenu()
    // 清理事件监听
    this.globalEventBus.off('openSubscriptionPage', this.openSubPage)
    this.cleanupMobilePageLayout()
  },
  methods: {
    handleSidebarScroll() {
      if (!this.touchNavigation) return
      if (this.isMobileViewport && this.userMenuVisible && !this.mobileDrawerOpen) return
      // 短屏滚动会移走浮层锚点；一起收起，避免固定菜单悬在旧位置。
      if (this.userMenuVisible || this.inviteMenuVisible || this.contactInfoVisible) {
        const focusedPanel = [this.$refs.userMenuPanel, this.$refs.inviteMenuPanel, this.$refs.contactMenuPanel,
          this.$refs.teamMenuPanel, document.querySelector('.language-popover-container')]
          .some(panel => panel?.contains(document.activeElement))
        const trigger = this.userMenuVisible ? this.userMenuTrigger :
          this.inviteMenuVisible ? this.$refs.inviteMenuTrigger : this.contactInfoTrigger
        this.clearSidebarPopovers()
        if (focusedPanel && this.touchNavigation) trigger?.focus({ preventScroll: true })
      }
    },
    handleSidebarMenuScroll() {
      if (!this.touchNavigation) return
      if (this.languagePopoverVisible) this.positionMobileSidebarMenu()
      if (this.teamMenuVisible) this.updateTeamMenuPosition()
    },
    clearMobileAgentNavigation() {
      this.mobileDrawerNavigationId = null
      const pending = this.$store.getters['chat/mobileAgentNavigation']
      if (pending) this.$store.commit('chat/resolveMobileAgentNavigation', { id: pending.id, accepted: false })
    },
    selectMobileNavigationAgent(agent) {
      if (!this.isMobileViewport || !this.mobileDrawerOpen || !this.isLoggedIn || !agent?.id) return
      this.$store.commit('chat/queueMobileAgentNavigation', {
        agentId: agent.id,
        teamId: this.currentTeamId,
        userId: this.currentUserId
      })
      const id = this.$store.getters['chat/mobileAgentNavigation'].id
      this.mobileDrawerNavigationId = id
      if (this.$route.path === '/chat') return
      this.$router.push({ name: 'ChatCreation' }).then(failure => {
        if (failure) this.$store.commit('chat/resolveMobileAgentNavigation', { id, accepted: false })
      }).catch(error => {
        console.error('[mobile-navigation] 打开对话失败:', error)
        this.$store.commit('chat/resolveMobileAgentNavigation', { id, accepted: false })
      })
    },
    loadMobileProjectNavigation() {
      if (!this.isLoggedIn) return
      return this.$store.dispatch('mobileNavigation/loadProjects', { page: 1 })
    },
    retryMobileProjectNavigation() {
      return this.$store.dispatch('mobileNavigation/loadProjects', { page: 1, force: true })
    },
    loadMoreMobileProjectNavigation() {
      return this.$store.dispatch('mobileNavigation/loadProjects', {
        page: this.$store.getters['mobileNavigation/projectNextPage']
      })
    },
    loadMobileAssetNavigation() {
      if (!this.isLoggedIn) return
      return this.$store.dispatch('mobileNavigation/loadAssetFolders', { page: 1 })
    },
    retryMobileAssetNavigation() {
      return this.$store.dispatch('mobileNavigation/loadAssetFolders', { page: 1, force: true })
    },
    loadMoreMobileAssetNavigation() {
      return this.$store.dispatch('mobileNavigation/loadAssetFolders', {
        page: this.$store.getters['mobileNavigation/assetNextPage']
      })
    },
    selectMobileNavigationOverview(path) {
      const item = this.menus.find(menu => menu.path === path)
      if (item) this.changeNav(item)
    },
    selectMobileNavigationProject(project) {
      if (!this.isMobileViewport || !this.mobileDrawerOpen || !this.isLoggedIn || !project) return
      const target = project.def_doc_uniq_code
        ? { name: 'KnowledgeManage', params: { doc_uniq_code: String(project.def_doc_uniq_code) } }
        : { name: 'ProjectsSpaceManage', params: { uniq_code: String(project.uniq_code) } }
      const redirect = this.$router.resolve(target).fullPath
      if (!requireAuth({ reason: 'knowledge', redirect })) {
        this.closeMobileDrawer(false)
        return
      }
      this.closeMobileDrawer()
      this.$router.push(target)
    },
    selectMobileNavigationAsset(folder) {
      if (!this.isMobileViewport || !this.mobileDrawerOpen || !this.isLoggedIn || !folder?.code) return
      const target = { name: 'AssetFolderManagement', params: { folder_code: String(folder.code) } }
      const redirect = this.$router.resolve(target).fullPath
      if (!requireAuth({ reason: 'assets', redirect })) {
        this.closeMobileDrawer(false)
        return
      }
      this.closeMobileDrawer()
      this.$router.push(target)
    },
    updateMobileViewport() {
      const state = this.displayState || readDisplayState()
      const mobile = state.layoutMode === 'mobile'
      if (mobile === this.isMobileViewport) {
        if (this.touchNavigation) {
          this.positionMobileSidebarMenu()
          if (this.contactInfoVisible) this.showContactMenu()
        }
        return
      }
      const active = document.activeElement
      const previousTrigger = this.inviteMenuVisible ? this.$refs.inviteMenuTrigger :
        this.userMenuVisible ? this.userMenuTrigger : this.contactInfoVisible ? this.contactInfoTrigger : null
      const ownedFocus = [this.$refs.navigationAside?.$el, this.$refs.inviteMenuPanel,
        this.$refs.userMenuPanel, this.$refs.teamMenuPanel, document.querySelector('.language-popover-container'),
        document.querySelector('.contact-menu-popover')]
        .some(panel => panel?.contains(active))
      this.closeMobileDrawer(false)
      this.clearSidebarPopovers()
      this.isMobileViewport = mobile
      this.$nextTick(() => {
        if (!ownedFocus || this.blockingDialogVisible || this.mobileOverlayOpen ||
            this.isVisiblePublicFocusTarget(document.activeElement)) return
        const target = mobile ? this.mobileNavigationTrigger :
          this.isVisiblePublicFocusTarget(previousTrigger) ? previousTrigger : this.$refs.layoutMain?.$el
        if (this.isVisiblePublicFocusTarget(target)) target.focus({ preventScroll: true })
      })
    },
    positionMobileSidebarMenu() {
      if (!this.touchNavigation) return
      const viewport = this.getMenuViewport()
      const compact = this.isMobileViewport
      const positionFor = (panel, trigger, submenu = false) => {
        const bottomSheet = this.userMenuVisible && compact && !submenu
        if (!panel || (!bottomSheet && !this.isVisiblePublicFocusTarget(trigger))) return null
        // 底部菜单独立于已收起的侧栏，位置只取决于可视区域。
        const rect = bottomSheet ? viewport : trigger.getBoundingClientRect()
        const inlineStart = 'max(16px, env(safe-area-inset-left, 0px))'
        const inlineEnd = 'max(16px, env(safe-area-inset-right, 0px))'
        const blockStart = 'max(16px, env(safe-area-inset-top, 0px))'
        const blockEnd = 'max(16px, env(safe-area-inset-bottom, 0px))'
        const sidebarRect = this.$refs.navigationAside?.$el?.getBoundingClientRect()
        const above = rect.top - viewport.top
        const below = viewport.bottom - rect.bottom
        const openAbove = above >= below
        const sizing = {
          '--mobile-menu-width': `${Math.max(0, bottomSheet ? viewport.width : Math.min(submenu ? 180 : compact && sidebarRect ? sidebarRect.width - 24 : panel.offsetWidth || 220, viewport.width - 32))}px`,
          '--menu-viewport-width': `${viewport.width}px`,
          '--menu-viewport-height': `${viewport.height}px`,
          '--mobile-menu-max-height': bottomSheet
            ? `max(0px, calc(${viewport.height}px - ${blockStart}))`
            : submenu || !compact
            ? `calc(${viewport.height}px - ${blockStart} - ${blockEnd})`
            : `max(0px, calc(${openAbove ? above - 8 : below - 8}px - ${openAbove ? blockStart : blockEnd}))`
        }
        // 先约束卡片宽高再测量，主菜单只占入口一侧的空间，不遮挡底部入口。
        Object.entries(sizing).forEach(([name, value]) => panel.style.setProperty(name, value))
        const width = panel.offsetWidth
        const height = panel.offsetHeight
        const preferredLeft = bottomSheet ? viewport.left : submenu || !compact
          ? (rect.right + 8 + width <= viewport.right - 16 ? rect.right + 8 : rect.left - width - 8)
          : (sidebarRect?.left ?? rect.left) + 12
        const left = bottomSheet
          ? `${viewport.left}px`
          : `clamp(calc(${viewport.left}px + ${inlineStart}), ${preferredLeft}px, calc(${viewport.right}px - ${inlineEnd} - ${width}px))`
        const preferredTop = submenu ? rect.top : !compact ? rect.top + rect.height / 2 - height / 2 :
          openAbove ? rect.top - height - 8 : rect.bottom + 8
        const top = bottomSheet ? 'auto' : `clamp(calc(${viewport.top}px + ${blockStart}), ${preferredTop}px, calc(${viewport.bottom}px - ${height}px - ${blockEnd}))`
        panel.style.left = left
        panel.style.right = 'auto'
        // 语言子菜单本轮就要读取父卡片内的坐标，不能等待下一轮 Vue patch。
        panel.style.top = top
        panel.style.bottom = bottomSheet ? `max(0px, calc(${blockEnd}))` : 'auto'
        return {
          ...sizing,
          left,
          top,
          right: 'auto',
          bottom: bottomSheet ? `max(0px, calc(${blockEnd}))` : 'auto'
        }
      }
      const panel = this.inviteMenuVisible ? this.$refs.inviteMenuPanel :
        this.userMenuVisible ? this.$refs.userMenuPanel :
          this.contactInfoVisible ? this.$refs.contactMenuPanel : null
      const trigger = this.inviteMenuVisible ? this.$refs.inviteMenuTrigger :
        this.userMenuVisible ? this.userMenuTrigger : this.contactInfoTrigger
      const position = positionFor(panel, trigger)
      if (position) {
        if (this.inviteMenuVisible) this.inviteMenuPosition = position
        else if (this.userMenuVisible) this.userMenuPosition = position
        else this.contactInfoPosition = position
      }
      if (this.languagePopoverVisible) {
        const languagePosition = positionFor(document.querySelector('.language-popover-container'),
          this.$refs.languageMenuRef, true)
        if (languagePosition) this.languageMenuPosition = languagePosition
      }
    },
    clearSidebarPopovers() {
      this.cancelHideContactMenu()
      this.userMenuVisible = false
      this.languagePopoverVisible = false
      this.inviteMenuVisible = false
      this.contactInfoVisible = false
    },
    openMobileDrawer() {
      if (!this.isMobileViewport || this.mobileDrawerOpen || this.mobileOverlayOpen || this.blockingDialogVisible) return
      this.clearSidebarPopovers()
      this.mobileDrawerReturnFocus = document.activeElement
      this.mobileDrawerNavigationId = null
      this.mobileDrawerOpen = true
      this.$nextTick(() => {
        // 等抽屉解除 visibility/inert 后再移入焦点，避免浏览器丢弃对隐藏按钮的 focus。
        window.requestAnimationFrame(() => {
          if (this.mobileDrawerOpen && !this.blockingDialogVisible && !this.mobileOverlayOpen) {
            this.$refs.mobileDrawerClose?.focus({ preventScroll: true })
          }
        })
      })
    },
    closeMobileDrawer(restoreFocus = true, cancelAgentNavigation = true) {
      if (cancelAgentNavigation) this.clearMobileAgentNavigation()
      if (!this.mobileDrawerOpen) return
      this.mobileDrawerOpen = false
      this.mobileDrawerNavigationId = null
      this.clearSidebarPopovers()
      const target = this.mobileDrawerReturnFocus
      this.mobileDrawerReturnFocus = null
      if (restoreFocus) {
        this.$nextTick(() => {
          // Layout 弹窗或业务 overlay 打开时不恢复背景焦点，避免与弹窗焦点管理竞态。
          if (!this.mobileDrawerOpen && target?.isConnected &&
              !this.blockingDialogVisible && !this.mobileOverlayOpen) {
            const focusTarget = this.isVisiblePublicFocusTarget(target) ? target :
              this.mobileNavigationTrigger
            if (this.isVisiblePublicFocusTarget(focusTarget)) focusTarget.focus({ preventScroll: true })
          }
        })
      }
    },
    handleMobileDrawerKeydown(event) {
      if (this.blockingDialogVisible || this.mobileOverlayOpen) return
      const popupOpen = this.userMenuVisible || this.inviteMenuVisible || this.contactInfoVisible || this.languagePopoverVisible
      const accountSheetOpen = this.isMobileViewport && this.userMenuVisible
      if (!this.mobileDrawerOpen && !accountSheetOpen && !(this.displayState.isIPad && popupOpen)) return
      if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        if (this.teamMenuVisible) {
          this.closeTeamMenu(true)
          return
        }
        if (this.languagePopoverVisible) {
          this.languagePopoverVisible = false
          this.$nextTick(() => this.$refs.languageMenuRef?.focus({ preventScroll: true }))
          return
        }
        if (this.userMenuVisible || this.inviteMenuVisible) {
          const trigger = accountSheetOpen ? this.mobileNavigationTrigger :
            this.userMenuVisible ? this.userMenuTrigger : this.$refs.inviteMenuTrigger
          this.userMenuVisible = false
          this.inviteMenuVisible = false
          this.$nextTick(() => trigger?.focus({ preventScroll: true }))
          return
        }
        if (this.contactInfoVisible) {
          this.contactInfoVisible = false
          this.$nextTick(() => this.contactInfoTrigger?.focus({ preventScroll: true }))
          return
        }
        this.closeMobileDrawer()
        return
      }
      if (event.key !== 'Tab' || (!this.mobileDrawerOpen && !accountSheetOpen)) return
      const popup = this.inviteMenuVisible ? this.$refs.inviteMenuPanel :
        this.userMenuVisible ? this.$refs.userMenuPanel :
        this.contactInfoVisible ? document.querySelector('.contact-menu-popover') : null
      if (popup) {
        const panels = this.teamMenuVisible
          ? [this.$refs.teamMenuPanel]
          : this.languagePopoverVisible
            ? [popup, document.querySelector('.language-popover-container')] : [popup]
        const targets = panels.filter(Boolean).flatMap(panel =>
          Array.from(panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'))
            .filter(target => target.tabIndex >= 0 && target.getClientRects().length > 0))
        const first = targets[0]
        const last = targets[targets.length - 1]
        if (first && (
          !panels.some(panel => panel.contains(document.activeElement)) ||
          (event.shiftKey ? document.activeElement === first : document.activeElement === last)
        )) {
          event.preventDefault()
          const target = event.shiftKey ? last : first
          target.focus()
        }
        return
      }
      const drawer = this.$refs.navigationAside?.$el
      if (!drawer) return
      const targets = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]'))
        .filter(target => target.tabIndex >= 0 && target.getClientRects().length > 0)
      const first = targets[0]
      const last = targets[targets.length - 1]
      if (!first) return
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
        event.preventDefault()
        first.focus()
      }
    },
    openLogin() {
      this.closeMobileDrawer(false)
      requireAuth({
        reason: 'auth_required',
        redirect: this.$route.fullPath
      })
    },
    handleMobileBackClick() {
      // 返回目标与行为由页面维护；disabled 或无 onClick 时不执行，也不做默认跳转。
      const back = this.mobileBackConfig
      if (!back || back.disabled) return
      try {
        back.onClick()
      } catch (error) {
        // 不吞掉异常后自行导航；只记录，返回逻辑仍归页面。
        console.error('[mobilePageLayout] 页面返回处理异常:', error)
      }
    },
    loadPreferences() {
      if (!isAuthenticated()) return Promise.resolve(null)
      getPreferenceConfigs()
        .then(({ code, data }) => {
          if (code === 0) {
            console.log(data)
            this.languageOptions = (data.find(c => c.key === 'language')?.data || []).sort((a, b) => {
              const order = { 'en-us': 1, 'zh-cn': 2, 'zh-tw': 3 }
              return (order[a.key] || 999) - (order[b.key] || 999)
            })
            const themeOptionsData = data.find(c => c.key === 'theme')?.data || []
            this.themeOptions = themeOptionsData.map(item => {
              return {
                ...item,
                name: this.$t(`layout.layout.${item.key}`)
              }
            })
            this.setCurrentLanguage()
            this.$nextTick(() => {
              // 首次打开时异步选项会改变菜单高度，不能沿用空菜单的测量值。
              if (this.isMobileViewport && this.userMenuVisible) this.positionMobileSidebarMenu()
            })
          }
        })
        .catch(e => {
          console.error('配置加载失败:', e)
        })
    },
    getCurrentPreferences() {
      if (!isAuthenticated()) return Promise.resolve(null)
      getUserPreference()
        .then(({ code, data }) => {
          if (code === 0) {
            // 从后端获取主题设置并转换为对应的key
            const themeKey = getThemeKeyById(data.theme_id)
            const userSetLanguage = data.language_key.toLowerCase()
            if (userSetLanguage !== this.languageValue) {
              this.languageValue = userSetLanguage
              this.handleLangCommand(userSetLanguage, 0)
            }
            if (themeKey !== this.themeValue) {
              this.themeValue = themeKey
              switchTheme(this.themeValue, this.$store)
            }
          }
        })
        .catch(e => {
          console.error('用户设置加载失败:', e)
        })
    },
    themeValueChange() {
      // 应用主题变更
      const actual = switchTheme(this.themeValue, this.$store)
      // 广播主题变更，供 BlockNote/Mermaid 等订阅
      EventBus.emit('blocknote-theme-change', actual)
      this.savePreferences()
    },
    languageValueChange() {
      this.savePreferences()
    },
    savePreferences() {
      const params = {
        theme_id: this.themeOptions.find(t => t.key === this.themeValue)?.id,
        language_id: this.languageOptions.find(l => l.key === this.languageValue)?.id
      }
      const localeLanguage = getLocale()
      updateUserPreference(params).then(response => {
        if (localeLanguage !== this.languageValue) {
          this.changeLanguage()
        }
        // 主题切换不需要重新加载页面，已在themeValueChange中处理
      })
        .catch(error => {
          if (localeLanguage !== this.languageValue) {
            this.changeLanguage()
          }
          console.error('保存失败:', error)
        })
    },
    goToDashboard() {
      this.closeMobileDrawer()
      this.$router.push({name: 'Home'})
    },
    toggleMenuCollapse() {
      this.menuCollapse = true
    },
    changeNav(item) {
      if (['/chat', '/projects', '/assets'].includes(item.path) && !requireAuth({
        reason: item.path === '/chat' ? 'chat' : item.path === '/projects' ? 'knowledge' : 'assets',
        redirect: item.path
      })) {
        this.closeMobileDrawer(false)
        return
      }
      this.closeMobileDrawer()
      this.$nextTick(() => {
        if (this.$refs['createTeamDlg']) {
          this.$refs['createTeamDlg'].hide()
        }
      })
      this.$router.push({path: item.path})
    },
    openAccountCenter(event) {
      if (!requireAuth({ reason: 'account', redirect: this.$route.fullPath })) return
      this.accountCenterPreviousFocus = document.activeElement
      this.accountCenterReturnFocus = this.isMobileViewport ? document.activeElement :
        event?.currentTarget || document.activeElement
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogAccountCenter = true
    },
    openSubPage() {
      if (!requireAuth({ reason: 'subscription', redirect: this.$route.fullPath })) return
      if (!this.canManageSubscription) {
        this.$message.warning(this.$t('views.account_center.purchase_owner_only'))
        return
      }
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogSubscriptionPurchase = true
    },
    openSubscriptionCenter(event) {
      if (!requireAuth({ reason: 'subscription', redirect: this.$route.fullPath })) return
      this.accountCenterPreviousFocus = document.activeElement
      this.accountCenterReturnFocus = this.isMobileViewport ? document.activeElement :
        event?.currentTarget || document.activeElement
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogAccountCenter = true
      this.$nextTick(() => {
        EventBus.emit('setActiveMenu', 'subscription_manage', { resetTab: true })
      })
    },
    closeAccountCenter() {
      this.dialogAccountCenter = false
    },
    handleAccountCenterClosed() {
      if (this.dialogAccountCenter) return
      const opener = this.accountCenterReturnFocus
      const previousFocus = this.accountCenterPreviousFocus
      this.accountCenterReturnFocus = null
      this.accountCenterPreviousFocus = null
      this.$nextTick(() => {
        // Element Plus 先恢复原焦点；仅补救已隐藏的入口，不抢接管弹层或页面有效焦点。
        if (this.dialogAccountCenter || this.blockingDialogVisible || this.mobileOverlayOpen ||
            (this.isMobileViewport && this.mobileDrawerOpen) || this.userMenuVisible || this.languagePopoverVisible ||
            this.inviteMenuVisible || this.contactInfoVisible) return
        const isVisibleTarget = target => {
          if (!target?.isConnected || typeof target.focus !== 'function' ||
              target === document.body || target === document.documentElement || target.disabled ||
              target.closest('[inert], [aria-hidden="true"]') || !target.getClientRects().length) return false
          const style = window.getComputedStyle(target)
          const rect = target.getBoundingClientRect()
          return style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
            rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth
        }
        const active = document.activeElement
        if (isVisibleTarget(active) && (this.isMobileViewport || active !== previousFocus || active === opener)) return
        const fallback = this.isMobileViewport ? this.mobileNavigationTrigger : this.userMenuTrigger
        const target = isVisibleTarget(opener) ? opener : isVisibleTarget(fallback) ? fallback :
          !this.isMobileViewport && this.$refs.layoutMain?.$el
        if (isVisibleTarget(target)) target.focus({ preventScroll: true })
      })
    },
    accountCenterPaymentSuccess(payload){
      this.handleSubscriptionPaymentSuccess(payload)
      this.dialogAccountCenter = false
      this.handleSubscriptionDialogClosed()
    },
    handleSubscriptionPaymentSuccess(payload) {
      this.pendingSubscriptionPaymentSuccess = payload?.dialogData || null
      this.dialogSubscriptionPurchase = false
    },
    handleSubscriptionDialogClosed() {
      if (!this.pendingSubscriptionPaymentSuccess) return
      this.subscriptionPaymentSuccessData = this.pendingSubscriptionPaymentSuccess
      this.pendingSubscriptionPaymentSuccess = null
      this.subscriptionPaymentSuccessVisible = true
    },
    closeSubscriptionPaymentSuccess() {
      this.subscriptionPaymentSuccessVisible = false
    },
    toggleUserMenu(event) {
      event.stopPropagation()
      if (!requireAuth({ reason: 'account', redirect: this.$route.fullPath })) return
      const opening = !this.userMenuVisible
      // 收起导航会清理菜单，因此先关闭左栏，再打开独立的用户菜单。
      if (opening && this.isMobileViewport) this.closeMobileDrawer(false)
      this.userMenuVisible = opening
      if (!this.userMenuVisible) this.closeTeamMenu()

      if (this.userMenuVisible) {
        this.cancelHideContactMenu()
        this.contactInfoVisible = false
        this.getCurrentPreferences()
        this.loadPreferences()
        if(!this.$store.getters['team/currentTeam']){
          this.getUserTeam()
        }
        this.$store.dispatch('team/loadCurrentContext')
        this.inviteMenuVisible = false
      }

      // 如果点击时已经打开语言菜单，则关闭它
      if (this.languagePopoverVisible) {
        this.languagePopoverVisible = false
      }

      if (this.userMenuVisible) {
        this.$nextTick(() => {
          if (!this.userMenuVisible) return
          const trigger = this.userMenuTrigger
          if (trigger) {
            if (this.touchNavigation) {
              this.positionMobileSidebarMenu()
              this.$refs.userMenuFirstAction?.focus({ preventScroll: true })
              return
            }
            this.positionDesktopUserMenu()
          }
        })
      } else if (this.touchNavigation) {
        this.$nextTick(() => {
          const trigger = this.isMobileViewport ? this.mobileNavigationTrigger : this.userMenuTrigger
          trigger?.focus({ preventScroll: true })
        })
      }
    },
    toggleTeamMenu() {
      if (!this.userMenuVisible) return
      this.teamMenuVisible = !this.teamMenuVisible
      this.languagePopoverVisible = false
      if (!this.teamMenuVisible) return

      this.$nextTick(() => {
        if (!this.teamMenuVisible || !this.userMenuVisible) return
        this.updateTeamMenuPosition()
        if (this.touchNavigation) {
          this.$refs.teamMenuPanel?.querySelector('button:not([disabled])')?.focus({ preventScroll: true })
        }
      })
    },
    closeTeamMenu(restoreFocus = false) {
      this.teamMenuVisible = false
      if (restoreFocus && this.touchNavigation) {
        this.$nextTick(() => {
          if (this.userMenuVisible && !this.teamMenuVisible && !this.blockingDialogVisible && !this.mobileOverlayOpen) {
            this.teamMenuTrigger?.focus({ preventScroll: true })
          }
        })
      }
    },
    handleTeamMenuViewportChange() {
      if (this.touchNavigation) {
        if (this.userMenuVisible || this.inviteMenuVisible || this.contactInfoVisible || this.languagePopoverVisible) {
          this.positionMobileSidebarMenu()
        }
        if (this.teamMenuVisible) this.updateTeamMenuPosition()
        return
      }
      if (this.teamMenuVisible) this.updateTeamMenuPosition()
    },
    handleMobileVisualViewportChange() {
      if (!this.touchNavigation) return
      this.handleTeamMenuViewportChange()
    },
    getMenuViewport() {
      const visualViewport = window.visualViewport
      const left = Number.isFinite(visualViewport?.offsetLeft) ? visualViewport.offsetLeft : 0
      const top = Number.isFinite(visualViewport?.offsetTop) ? visualViewport.offsetTop : 0
      const width = Number.isFinite(visualViewport?.width) && visualViewport.width > 0
        ? visualViewport.width : window.innerWidth
      const height = Number.isFinite(visualViewport?.height) && visualViewport.height > 0
        ? visualViewport.height : window.innerHeight
      return {
        left,
        top,
        width,
        height,
        right: left + width,
        bottom: top + height
      }
    },
    positionDesktopUserMenu() {
      const panel = this.$refs.userMenuPanel
      const trigger = this.userMenuTrigger
      if (!this.userMenuVisible || this.touchNavigation || !panel || !trigger) return
      const rect = trigger.getBoundingClientRect()
      const windowHeight = window.innerHeight
      const menuHeight = 300

      if (windowHeight - rect.bottom < menuHeight) {
        this.userMenuPosition.left = `${rect.right + 15}px`
        this.userMenuPosition.top = 'auto'
        this.userMenuPosition.bottom = `${windowHeight - rect.top}px`
      } else {
        this.userMenuPosition.left = `${rect.right + 15}px`
        this.userMenuPosition.top = `${rect.top - 90}px`
        this.userMenuPosition.bottom = 'auto'
      }
    },
    updateTeamMenuPosition() {
      const trigger = this.teamMenuTrigger
      const popover = document.querySelector('.team-switch-popover')
      if (!trigger || !popover) return

      if (!this.touchNavigation) {
        const rect = trigger.getBoundingClientRect()
        const viewportPadding = 12
        const gap = 8
        const popoverWidth = popover.offsetWidth || 240
        const popoverHeight = popover.offsetHeight || 220
        const canOpenRight = rect.right + gap + popoverWidth <= window.innerWidth - viewportPadding
        const left = canOpenRight
          ? rect.right + gap
          : Math.max(viewportPadding, rect.left - gap - popoverWidth)
        const top = Math.max(
          viewportPadding,
          Math.min(rect.top, window.innerHeight - popoverHeight - viewportPadding)
        )

        this.teamMenuPosition.left = `${left}px`
        this.teamMenuPosition.right = 'auto'
        this.teamMenuPosition.top = `${top}px`
        this.teamMenuPosition.bottom = 'auto'
        return
      }

      const viewport = this.getMenuViewport()
      popover.style.setProperty('--menu-viewport-height', `${viewport.height}px`)
      popover.style.setProperty('--menu-viewport-width', `${viewport.width}px`)
      const rect = trigger.getBoundingClientRect()
      const viewportPadding = 12
      const gap = 8
      const popoverWidth = popover.offsetWidth || 240
      const popoverHeight = popover.offsetHeight || 220
      const canOpenRight = rect.right + gap + popoverWidth <= viewport.right - viewportPadding
      const preferredLeft = canOpenRight ? rect.right + gap : rect.left - gap - popoverWidth
      const left = Math.max(
        viewport.left + viewportPadding,
        Math.min(preferredLeft, viewport.right - popoverWidth - viewportPadding)
      )
      const top = Math.max(
        viewport.top + viewportPadding,
        Math.min(rect.top, viewport.bottom - popoverHeight - viewportPadding)
      )
      this.teamMenuPosition = {
        '--menu-viewport-height': `${viewport.height}px`,
        '--menu-viewport-width': `${viewport.width}px`,
        left: `${left}px`,
        right: 'auto',
        top: `${top}px`,
        bottom: 'auto'
      }
    },
    getTeamDisplayName(team) {
      if (Number(team && team.team_type) > 0) {
        return this.$store.getters['user/nick_name'] ||
          team.name ||
          this.$t('layout.layout.personal_team')
      }
      return (team && team.name) || this.$t('layout.layout.enterprise_team')
    },
    getTeamIconClass(team) {
      return Number(team && team.team_type) > 0 ? 'icon-user' : 'icon-company'
    },
    isCurrentTeam(team) {
      return Number(team && team.team_id) === Number(this.$store.getters['user/current_team_id'])
    },
    showContactMenu() {
      this.cancelHideContactMenu()
      this.contactInfoVisible = true
      this.closeTeamMenu()
      this.userMenuVisible = false
      this.languagePopoverVisible = false
      this.inviteMenuVisible = false

      if (this.contactInfoVisible) {
        this.$nextTick(() => {
          if (!this.contactInfoVisible) return
          if (this.touchNavigation) {
            this.positionMobileSidebarMenu()
            return
          }
          this.positionContactMenu()
        })
      }
    },
    positionContactMenu() {
      const trigger = this.contactInfoTrigger
      const menu = this.$refs.contactMenuPanel
      if (!this.contactInfoVisible || !trigger || !menu) return
      const rect = trigger.getBoundingClientRect()
      const menuHeight = menu.offsetHeight || 96
      const viewportPadding = 12
      const centeredTop = rect.top + (rect.height / 2) - (menuHeight / 2)
      const top = Math.max(
        viewportPadding,
        Math.min(centeredTop, window.innerHeight - menuHeight - viewportPadding)
      )

      this.contactInfoPosition.left = `${rect.right + 15}px`
      this.contactInfoPosition.top = `${top}px`
      this.contactInfoPosition.right = 'auto'
      this.contactInfoPosition.bottom = 'auto'
    },
    loadContactMenuItems() {
      getContactMenuList().then(response => {
        if (response && response.code === 0 && Array.isArray(response.data)) {
          this.contactMenuRecords = response.data
        }
      }).catch(error => {
        // 联系菜单属于增强配置，读取失败时保留固定的“联系我们”入口。
        console.warn('加载联系我们菜单失败:', error)
      })
    },
    openContactMenuItem(item) {
      if (item.key === 'contact') {
        this.openContactDialog()
        return
      }
      if (item.url) {
        window.open(item.url, '_blank', 'noopener,noreferrer')
      }
    },
    scheduleHideContactMenu() {
      // 触屏没有稳定的 hover 生命周期，点击入口后保留信息卡，交由全局外部点击关闭。
      if (this.isMobileViewport || (this.displayState.isIPad && !this.displayState.hasHover)) return
      this.cancelHideContactMenu()
      this.contactMenuHideTimer = window.setTimeout(() => {
        this.contactInfoVisible = false
        this.contactMenuHideTimer = null
      }, 220)
    },
    cancelHideContactMenu() {
      if (this.contactMenuHideTimer) {
        window.clearTimeout(this.contactMenuHideTimer)
        this.contactMenuHideTimer = null
      }
    },
    openContactDialog() {
      this.cancelHideContactMenu()
      this.contactInfoVisible = false
      this.contactDialogVisible = true
    },
    openEnterpriseContact() {
      this.enterpriseContactReturnFocus = document.activeElement
      this.closeMobileDrawer(false)
      this.enterpriseContactDialogVisible = true
    },
    handleEnterpriseContactClosed() {
      const opener = this.enterpriseContactReturnFocus
      this.enterpriseContactReturnFocus = null
      this.$nextTick(() => {
        if (!this.isMobileViewport || this.blockingDialogVisible || this.mobileOverlayOpen || this.mobileDrawerOpen) return
        const visible = target => {
          if (!target?.isConnected || !target.getClientRects().length ||
              target.closest('[inert], [aria-hidden="true"]') || typeof target.focus !== 'function') return false
          const style = window.getComputedStyle(target)
          const rect = target.getBoundingClientRect()
          return style.visibility === 'visible' && rect.bottom > 0 && rect.right > 0 &&
            rect.top < window.innerHeight && rect.left < window.innerWidth &&
            (!target.closest('.layout-container-aside') || this.mobileDrawerOpen)
        }
        if (visible(document.activeElement) && document.activeElement !== document.body) return
        const target = visible(opener) ? opener : this.mobileNavigationTrigger
        if (visible(target)) target.focus({ preventScroll: true })
      })
    },
    toggleLanguagePopover(event) {
      event.stopPropagation()
      this.closeTeamMenu()
      this.languagePopoverVisible = !this.languagePopoverVisible

      if (this.languagePopoverVisible) {
        this.$nextTick(() => {
          if (!this.languagePopoverVisible) return
           if (this.touchNavigation) {
             this.positionMobileSidebarMenu()
             document.querySelector('.language-popover-container input:not([disabled]):not([tabindex="-1"])')?.focus()
             return
           }
            const menuEl = this.$refs.languageMenuRef
            if (menuEl) {
              const rect = menuEl.getBoundingClientRect()
              const windowHeight = window.innerHeight
              const windowWidth = window.innerWidth
              const popoverWidth = 110
              const popoverHeight = 150

              if (windowWidth - rect.right < popoverWidth + 10) {
                this.languageMenuPosition.right = `${windowWidth - rect.left + 5}px`
                this.languageMenuPosition.left = 'auto'
              } else {
                this.languageMenuPosition.left = `${rect.right + 5}px`
                this.languageMenuPosition.right = 'auto'
              }

              if (windowHeight - rect.bottom < popoverHeight) {
                this.languageMenuPosition.top = 'auto'
                this.languageMenuPosition.bottom = `${windowHeight - rect.top - 136}px`
              } else {
                this.languageMenuPosition.top = `${rect.top}px`
                this.languageMenuPosition.bottom = 'auto'
              }
            }
        })
      }
    },
    changeLanguage() {
      // 如果事件对象存在，阻止冒泡
      this.handleLangCommand(this.languageValue)

      // 关闭语言弹窗，但保持用户菜单打开
      this.languagePopoverVisible = false

      // 这里添加切换语言的具体实现
    },
    handleGlobalClick(event) {
      // 处理用户菜单
      const userMenuEl = this.userMenuTrigger
      const userMenuContainer = document.querySelector('.custom-user-menu-container')
      const teamMenuContainer = document.querySelector('.team-switch-popover')

      if ((!userMenuEl || !userMenuEl.contains(event.target)) &&
          (!userMenuContainer || !userMenuContainer.contains(event.target)) &&
          (!teamMenuContainer || !teamMenuContainer.contains(event.target))) {
        if (this.touchNavigation && this.userMenuVisible &&
            (userMenuContainer?.contains(document.activeElement) || teamMenuContainer?.contains(document.activeElement))) {
          this.restoreHiddenMenuFocus(this.userMenuTrigger)
        }
        this.userMenuVisible = false
      }

      const teamMenuTrigger = this.teamMenuTrigger
      if ((!teamMenuTrigger || !teamMenuTrigger.contains(event.target)) &&
          (!teamMenuContainer || !teamMenuContainer.contains(event.target))) {
        this.closeTeamMenu()
      }

      // 处理语言菜单
      const languageMenuEl = this.$refs.languageMenuRef
      const popoverEl = document.querySelector('.language-popover-container')

      if ((!languageMenuEl || !languageMenuEl.contains(event.target)) &&
          (!popoverEl || !popoverEl.contains(event.target))) {
        this.languagePopoverVisible = false
      }

      // 处理邀请菜单
      const inviteMenuEl = document.querySelector('.invite-menu-popover')
      const inviteRewardEntry = document.querySelector('.invite-reward-entry')
      if ((!inviteRewardEntry || !inviteRewardEntry.contains(event.target)) &&
          (!inviteMenuEl || !inviteMenuEl.contains(event.target))) {
        if (this.touchNavigation && this.inviteMenuVisible &&
            inviteMenuEl?.contains(document.activeElement)) {
          this.restoreHiddenMenuFocus(this.$refs.inviteMenuTrigger)
        }
        this.inviteMenuVisible = false
      }

      const contactInfoTrigger = this.contactInfoTrigger
      const contactInfoPopover = document.querySelector('.contact-menu-popover')
      if ((!contactInfoTrigger || !contactInfoTrigger.contains(event.target)) &&
          (!contactInfoPopover || !contactInfoPopover.contains(event.target))) {
        if (this.touchNavigation && this.contactInfoVisible &&
            contactInfoPopover?.contains(document.activeElement)) {
          this.restoreHiddenMenuFocus(this.contactInfoTrigger)
        }
        this.contactInfoVisible = false
      }
    },
    restoreHiddenMenuFocus(trigger) {
      this.$nextTick(() => {
        if (!this.touchNavigation || (this.isMobileViewport && !this.mobileDrawerOpen) || this.blockingDialogVisible ||
            this.mobileOverlayOpen || this.userMenuVisible || this.inviteMenuVisible) return
        if (document.activeElement?.getClientRects().length && document.activeElement !== document.body) return
        if (trigger?.isConnected && trigger.getClientRects().length) trigger.focus({ preventScroll: true })
      })
    },
    toggleInviteMenu(event) {
      event.stopPropagation()
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      const trigger = event.currentTarget
      this.inviteMenuVisible = !this.inviteMenuVisible

      if (this.inviteMenuVisible) {
        this.closeTeamMenu()
        this.cancelHideContactMenu()
        this.contactInfoVisible = false
        this.userMenuVisible = false
        this.languagePopoverVisible = false
        this.$nextTick(() => {
          if (!this.inviteMenuVisible) return
          if (trigger) {
            const rect = trigger.getBoundingClientRect()
            if (this.touchNavigation) {
              this.positionMobileSidebarMenu()
              this.$refs.inviteMenuFirstAction?.focus({ preventScroll: true })
              return
            }
            this.inviteMenuPosition.left = `${rect.right + 15}px`
            const popover = document.querySelector('.invite-menu-popover')
            const menuHeight = popover ? popover.offsetHeight : 90
            this.inviteMenuPosition.top = `${rect.top + (rect.height / 2) - (menuHeight / 2)}px`
            this.inviteMenuPosition.bottom = 'auto'
          }
        })
      } else if (this.touchNavigation) {
        this.$nextTick(() => this.$refs.inviteMenuTrigger?.focus({ preventScroll: true }))
      }
    },
    openInviteReward(event) {
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      this.inviteDialogReturnFocus = {
        kind: 'reward', id: ++this.inviteDialogFocusSeq,
        opener: event?.currentTarget || document.activeElement
      }
      this.inviteMenuVisible = false
      if (this.isMobileViewport) this.closeMobileDrawer(false)
      this.dialogInviteReward = true
    },
    openBindInviteCode(event) {
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      this.inviteDialogReturnFocus = {
        kind: 'bind', id: ++this.inviteDialogFocusSeq,
        opener: event?.currentTarget || document.activeElement
      }
      this.inviteMenuVisible = false
      if (this.isMobileViewport) this.closeMobileDrawer(false)
      this.dialogBindInviteCode = true
    },
    handleInviteDialogClosed(kind) {
      const pending = this.inviteDialogReturnFocus
      if (pending?.kind !== kind || this.dialogInviteReward || this.dialogBindInviteCode) return
      this.inviteDialogReturnFocus = null
      this.$nextTick(() => {
        if (pending.id !== this.inviteDialogFocusSeq || this.blockingDialogVisible ||
            this.mobileOverlayOpen || this.mobileDrawerOpen) return
        if (this.isVisiblePublicFocusTarget(document.activeElement)) return
        const fallback = this.isMobileViewport ? this.mobileNavigationTrigger : this.$refs.inviteMenuTrigger
        const target = [pending.opener, fallback, this.$refs.layoutMain?.$el]
          .find(candidate => this.isVisiblePublicFocusTarget(candidate))
        target?.focus({ preventScroll: true })
      })
    },
    isVisiblePublicFocusTarget(target) {
      if (!target?.isConnected || target === document.body || typeof target.focus !== 'function' ||
          !target.getClientRects().length || target.matches(':disabled') ||
          target.closest('[inert], [aria-hidden="true"]')) return false
      const style = window.getComputedStyle(target)
      const rect = target.getBoundingClientRect()
      return style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
        rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth
    },
    openMenu(key, keyPath) {
    },
    closeMenu(key, keyPath) {
    },
    updateActiveMenu(path) {
      if (path.indexOf('/chat') >= 0) {
        path = '/chat'
      } else if (path.indexOf('/projects') >= 0) {
        path = '/projects'
      } else if (path.indexOf('/assets') >= 0) {
        path = '/assets'
      }
      const menu = this.menus.find(o => o.path === path)
      if (menu) {
        this.menuActiveIndex = menu.code
      } else if (this.isMobileViewport) {
        this.menuActiveIndex = ''
      }
      this.curPath = path
    },
    userLogout() {
      this.closeMobileDrawer(false)
      this.$confirm(this.$t('layout.layout.confirm_logout'), this.$t('layout.layout.logout_system'), {
        confirmButtonText: this.$t('layout.layout.exit'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('user/logout')
        this.$router.replace('/home')
      }).catch(() => {
        // 用户取消操作，不做任何处理
      })
    },
    closeDialogCreateTeam() {
      if (this.createTeamBusy) return
      this.dialogCreateTeam = false
    },
    submitCreateTeam() {
      this.$refs['createTeamDlg'].createTeam()
    },
    showDialogCreateTeam() {
      this.closeTeamMenu()
      this.createTeamBusy = false
      this.dialogCreateTeam = true
      this.$nextTick(() => {
        if (this.$refs['createTeamDlg']) {
          this.$refs['createTeamDlg'].initCreateTeam()
        }
      })
      this.userMenuVisible = false
    },
    closeDialogJoinTeam() {
      if (this.joinTeamBusy) return
      this.dialogJoinTeam = false
    },
    submitJoinTeam() {
      this.$refs['joinTeamDlg'].joinTeam()
    },
    showDialogJoinTeam() {
      this.closeTeamMenu()
      this.joinTeamBusy = false
      this.dialogJoinTeam = true
      this.$nextTick(() => {
        if (this.$refs['joinTeamDlg']) {
          this.$refs['joinTeamDlg'].initJoinTeam()
        }
      })
      this.userMenuVisible = false
    },
    confirmLeaveCurrentTeam() {
      this.$confirm(
        this.$t('layout.layout.confirm_leave_team'),
        this.$t('common.tips'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => this.leaveCurrentTeam()).catch(() => {})
    },
    async leaveCurrentTeam() {
      try {
        const response = await leaveTeam({})
        if (!response || response.code !== 0) return
        this.$message.success(this.$t('layout.layout.leave_team_success'))
        const teams = await this.getUserTeam()
        const personalTeam = (teams || []).find(item => Number(item.team_type) > 0)
        if (personalTeam && personalTeam.team_id) {
          await this.switchUserCurrIdentity(personalTeam.team_id)
        } else {
          this.userMenuVisible = false
        }
      } catch (error) {
        // request.js already surfaces the backend error message
      }
    },
    updateTeam(id) {
      this.dialogCreateTeam = false
      this.dialogJoinTeam = false
      this.switchUserCurrIdentity(id)
      this.getUserTeam()
    },
    async switchUserCurrIdentity(teamId) {
      if (!teamId || this.teamSwitchingId !== null) return
      if (Number(this.$store.getters['user/current_team_id']) === Number(teamId)) {
        this.closeTeamMenu(true)
        return
      }

      this.teamSwitchingId = teamId
      try {
        const response = await switchCurrIdentity({ current_team_id: teamId })
        if (response && response.code === 0) window.location.href = '/'
      } catch (error) {
        // request.js already surfaces the backend error message
      } finally {
        this.teamSwitchingId = null
      }
    },
    openTeamManagement() {
      this.closeTeamMenu()
      this.userMenuVisible = false
      this.closeMobileDrawer(false)
      this.$router.push('/org-admin/index')
    },
    getUserTeam() {
      if (!isAuthenticated()) return Promise.resolve([])
      return this.$store.dispatch('team/load').catch(() => [])
    },
    showDialogTeamInvitation() {
      this.teamInvitationBusy = false
      this.dialogTeamInvitation = true
      this.userMenuVisible = false
    },
    confirmTeamInvitation() {
      this.dialogTeamInvitation = false
    },
    submitTeamInvitation() {
      this.$refs['teamInvitationDlg'].submitOption()
    },
    setCurrentLanguage() {
      if (this.languageOptions.length > 0) {
        this.currentLanguage = this.languageOptions.find(item => item.key === this.languageValue)
      }
    },
    async handleLangCommand(command, isReload = 1) {
      console.log(this.menus)
      const paramsLocale = command
      // 暂时先注释 本地有配置文件 后续更改为从后端获取
      await setLocale(i18n, paramsLocale)
      setI18nLanguage(i18n, paramsLocale)
      document.title = getPageTitle(this.$t(this.$route.meta.title))

      // 更新主题选项的翻译名称
      if (this.themeOptions.length > 0) {
        this.themeOptions = this.themeOptions.map(theme => {
          return {
            ...theme,
            name: this.$t(`layout.layout.${theme.key}`)
          }
        })
      }

      this.setCurrentLanguage()
      // this.menus = [...this.menus]
      if (isReload) {
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
@use '../views/mobile/layout/styles/invite-shell.scss';
@import '@/views/mobile/user_center/styles/team_entry_dialogs';
@import '@/views/mobile/user_center/styles/team_switch';
.accountCenterBox{
  padding: 0 !important;
  border-radius: 6px;
  .el-dialog__header {
    padding:0 !important;
  }
  .el-drawer__header { display: none; }
  .el-drawer__body { padding: 0; }
  .account-center-container {
    line-height: normal;
  }
}
.accountCenterBox.el-drawer {
  width: 100% !important;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  overflow: hidden;

  .el-drawer__body,
  .el-drawer__body > .account-center-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 0;
    overflow: hidden;
  }
}
@media (width > 768px) {
  .account-center-overlay .el-overlay-dialog .accountCenterBox {
    min-width: 0;
    max-width: calc(100% - 32px);
  }
}
@media (max-width: 768px) {
  .account-center-overlay .el-overlay-dialog {
    height: 100vh;
    height: 100dvh;
    padding: 0;
    overflow: hidden;

    .accountCenterBox {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: none;
      height: 100%;
      max-height: none;
      min-height: 0;
      margin: 0;
      padding: 0;
      border-radius: 0;
      overflow: hidden;
      background: var(--agst-bg-color, var(--el-bg-color));

      > .el-dialog__header {
        display: none;
      }

      > .el-dialog__body,
      > .el-dialog__body > .account-center-container {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        width: 100%;
        height: 100%;
        max-height: none;
        min-width: 0;
        min-height: 0;
        padding: 0;
        overflow: hidden;
      }
    }
  }
}
@media (min-width: 600px) and (max-width: 768px) {
  .account-center-overlay .el-overlay-dialog {
    --account-center-inline-inset: max(16px, env(safe-area-inset-left, 0px), env(safe-area-inset-right, 0px));
    --account-center-block-inset: max(16px, env(safe-area-inset-top, 0px), env(safe-area-inset-bottom, 0px));
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: var(--account-center-block-inset) var(--account-center-inline-inset);

    .accountCenterBox {
      flex: 0 1 auto;
      width: 100%;
      max-width: 720px;
      height: min(720px, calc(100vh - var(--account-center-block-inset) - var(--account-center-block-inset)));
      height: min(720px, calc(var(--app-visible-height, 100dvh) - var(--account-center-block-inset) - var(--account-center-block-inset)));
      max-height: 100%;
      margin: 0;
      border-radius: 12px;
    }
  }
}
html[data-device='ipad'] .account-center-overlay .el-overlay-dialog,
html[data-device='phone'][data-layout-mode='desktop'] .account-center-overlay .el-overlay-dialog {
  top: var(--app-visible-top, 0px);
  height: var(--app-visible-height, 100dvh);
}
html[data-device='ipad'][data-layout-mode='desktop'],
html[data-device='phone'][data-layout-mode='desktop'] {
  .account-center-overlay .el-overlay-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .account-center-overlay .el-overlay-dialog .accountCenterBox {
    --account-center-inline-inset: max(16px, env(safe-area-inset-left, 0px), env(safe-area-inset-right, 0px));
    --account-center-block-inset: max(16px, env(safe-area-inset-top, 0px), env(safe-area-inset-bottom, 0px));
    max-width: calc(100% - var(--account-center-inline-inset) - var(--account-center-inline-inset));
    margin-block: 0;

    .account-center-container {
      height: min(680px, calc(100vh - var(--account-center-block-inset) - var(--account-center-block-inset)));
      height: min(680px, calc(var(--app-visible-height, 100dvh) - var(--account-center-block-inset) - var(--account-center-block-inset)));
      min-height: 0;
    }
  }
}
html[data-device='phone'][data-layout-mode='desktop'] .accountCenterBox .account-center-container {
  position: relative;
  box-sizing: border-box;
  padding-top: 52px;

  .account-center-landscape-cancel {
    position: absolute;
    top: 4px;
    right: 12px;
    z-index: 1;
    min-width: 44px;
    min-height: 44px;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--agst-text-color-secondary, #909399);
    font-size: 20px;

    &:focus-visible {
      outline: 2px solid var(--agst-color-primary, #2d66f0);
      outline-offset: -2px;
    }
  }
}
.subscriptionPurchaseBox {
  max-width: calc(100vw - 28px);
  padding: 0 !important;
  overflow: hidden;
  border-radius: 10px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}
.subscriptionPurchaseBox.el-drawer {
  width: 100% !important;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  overflow: hidden;
  .el-drawer__header { display: none; }
  .el-drawer__body {
    min-height: 0;
    padding: 0 0 max(16px, env(safe-area-inset-bottom, 0px));
    overflow-y: auto;
    overscroll-behavior-y: contain;
  }
  .subscription-purchase.is-mobile {
    max-height: none;
    overflow: visible;
  }
}
.invite-reward-dialog {
  border-radius: 16px;
  .el-dialog__header {
    padding: 0 !important;
  }

}
.invite-reward-dialog.el-drawer {
  .el-drawer__header { display: none; }
  .el-drawer__body { min-height: 0; padding: 0; overflow: hidden; }
}
.contact-dialog {
  max-width: calc(100vw - 32px);
  border-radius: 12px;

  .el-dialog__header {
    padding: 24px 24px 12px;
    margin-right: 0;
  }

  .el-dialog__title {
    color: var(--agst-text-color-primary,#303133);
    font-size: 20px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 8px 24px 24px;
  }

  .contact-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .contact-dialog-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .contact-dialog-caption {
    color: var(--agst-text-color-primary,#303133);
    font-size: var(--agst-font-size-base,14px);
    font-weight: 600;
  }

  .contact-dialog-value,
  .contact-dialog-link {
    color: var(--agst-text-color-primary,#303133);
    font-size: var(--agst-font-size-base,14px);
    line-height: 1.55;
    word-break: break-all;
  }

  .contact-dialog-link {
    color: var(--agst-color-primary,#2D66F0);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .contact-dialog-qrcode {
    width: 116px;
    height: 116px;
    margin-top: 2px;
    border-radius: 4px;
    background: #fff;
  }
}
.contact-dialog.el-drawer {
  width: 100% !important;
  max-width: 520px;
  max-height: min(92vh, 720px);
  max-height: min(92dvh, 720px);
  padding: 0 16px max(16px, env(safe-area-inset-bottom));
  border-radius: 16px 16px 0 0;
  box-sizing: border-box;
  .el-drawer__header { flex: 0 0 auto; margin: 0; padding: 16px 44px 12px 8px; }
  .el-drawer__title { color: var(--agst-text-color-primary,#303133); font-size: 20px; font-weight: 600; }
  .el-drawer__close-btn { top: 8px; right: 4px; width: 44px; height: 44px; }
  .el-drawer__body { min-height: 0; padding: 8px 8px 0; overflow-y: auto; }
  .contact-dialog-content { gap: 20px; }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/iconfont/iconfont.css';
@import '@/assets/css/layout.scss';
@import '@/views/mobile/layout/styles/ipad.scss';
</style>

